<template>
	<div class="propuesta-page">
		<!-- Modal inicial: Nueva propuesta o Continuar existente -->
		<el-dialog
			title="Gestión de Propuestas"
			:visible.sync="modalInicial.visible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			width="500px"
			class="modal-inicial-propuesta"
		>
			<div v-if="loadingInicial" style="text-align: center; padding: 2rem;" v-loading="true" element-loading-text="Cargando...">
				<p style="font-size: 1.1rem; margin-top: 3rem;">Cargando...</p>
			</div>
			<div v-else-if="modalInicial.paso === 1">
				<p style="text-align: center; margin-bottom: 2rem; font-size: 1.1rem;">
					¿Qué desea hacer?
				</p>
				<div style="display: flex; gap: 1rem; justify-content: center;">
					<el-button type="primary" size="medium" @click="seleccionarNuevaPropuesta">
						Nueva Propuesta
					</el-button>
					<el-button type="default" size="medium" @click="seleccionarContinuarPropuesta">
						Continuar Existente
					</el-button>
				</div>
			</div>

			<div v-else-if="modalInicial.paso === 2">
				<p style="text-align: center; margin-bottom: 2rem; font-size: 1.1rem;">
					Seleccione el tipo de propuesta:
				</p>
				<div style="display: flex; gap: 1rem; justify-content: center;">
					<el-button type="primary" size="medium" @click="seleccionarTipoPropuesta('MAQUINAS')">
						MÁQUINAS
					</el-button>
					<el-button type="primary" size="medium" @click="seleccionarTipoPropuesta('PUENTE')">
						PUENTE
					</el-button>
				</div>
				<div style="text-align: center; margin-top: 1rem;">
					<el-button type="text" @click="modalInicial.paso = 1">← Volver</el-button>
				</div>
			</div>

			<div v-else-if="modalInicial.paso === 3">
				<p style="text-align: center; margin-bottom: 1rem; font-size: 1.1rem;">
					Seleccione una propuesta pendiente:
				</p>
				<el-select
					v-model="propuestaSeleccionada"
					placeholder="Seleccione una propuesta"
					filterable
					style="width: 100%"
					:loading="loadingPropuestas"
					@change="cargarPropuestaSeleccionada"
				>
					<el-option
						v-for="prop in listaPropuestasPendientes"
						:key="prop.id"
						:label="`${prop.codigo} - ${prop.buque} (${prop.tipo})`"
						:value="prop.id"
					/>
				</el-select>
				<div style="text-align: center; margin-top: 1rem;">
					<el-button type="text" @click="modalInicial.paso = 1">← Volver</el-button>
				</div>
			</div>
		</el-dialog>

		<div class="propuesta-container" v-if="!modalInicial.visible">
			<!-- Header de la propuesta -->
			<div class="propuesta-header">
				<div class="header-row">
					<div class="header-field">
						<label>BUQUE:</label>
						<el-select
							v-model="propuesta.buqueId"
							placeholder="Seleccione un buque"
							size="small"
							:loading="loadingDestinos"
							:disabled="!!propuesta.numeroPropuesta"
							filterable
							@focus="cargarDestinos"
							style="width: 100%"
						>
							<el-option
								v-for="destino in listaDestinos"
								:key="destino.IDDESTINOS"
								:label="destino.DESTINO"
								:value="destino.IDDESTINOS"
							/>
						</el-select>
					</div>
					<div class="header-field">
						<label>{{ propuesta.tipo === 'PUENTE' ? 'CAPITAN:' : 'J.MAQUINAS:' }}</label>
						<el-input
							v-model="propuesta.jMaquinas"
							:placeholder="propuesta.tipo === 'PUENTE' ? 'Nombre del capitán' : 'Nombre del jefe de máquinas'"
							size="small"
						/>
					</div>
					<div class="header-field header-title">
						<h2>{{ propuesta.tipo === 'PUENTE' ? 'PROPUESTA DE PEDIDO PUENTE' : 'PROPUESTA DE PEDIDO MAQUINAS' }}</h2>
					</div>
					<div class="header-field">
						<label>FECHA:</label>
						<el-date-picker
							v-model="propuesta.fecha"
							type="date"
							format="dd/MM/yyyy"
							value-format="yyyy-MM-dd"
							placeholder="Fecha"
							size="small"
							:disabled="!!propuesta.numeroPropuesta"
							style="width: 100%"
						/>
					</div>
					<div class="header-field">
						<label>N° PROPUESTA PED.:</label>
						<el-input
							v-model="propuesta.numeroPropuesta"
							placeholder="Número de propuesta"
							size="small"
							:disabled="true"
							readonly
						/>
					</div>
				</div>
				<!-- Buscador global + botones de acción -->
				<div class="propuesta-actions">
					<div class="propuesta-actions-right">
						<el-autocomplete
							v-model="buscadorArticulosGlobal.texto"
							:fetch-suggestions="buscarArticulosGlobal"
							placeholder="Buscar artículo en toda la propuesta..."
							size="small"
							value-key="DESCRIPCION"
							@select="seleccionarArticuloGlobal"
							style="width: 100%; max-width: 800px;"
						>
							<template slot-scope="{ item }">
								<div>
									<div><strong>{{ item.CODIGO }}</strong> - {{ item.DESCRIPCION }}</div>
									<div v-if="item.__infoGrupo" style="font-size: 11px; color: #909399;">
										{{ item.__infoGrupo }}
									</div>
								</div>
							</template>
						</el-autocomplete>
					</div>
					<div class="propuesta-actions-left">
						<el-button type="primary" @click="guardarPropuesta">Guardar</el-button>
						<el-button @click="cerrarPropuesta">Lanzar propuesta</el-button>
					</div>
				</div>
			</div>

			<!-- Tabla de propuesta -->
			<div class="propuesta-table-container">
				<!-- Encabezados de columna -->
				<div class="table-header">
					<div class="col-posicion">POSICION</div>
					<div class="col-referencia">REFERENCIA</div>
					<div class="col-equipo">EQUIPO (MODELO, SN,_)</div>
					<div class="col-cantidad">Cantidad</div>
					<div class="col-unidad">Un. Medida</div>
					<div class="col-notas">Notas BARCO</div>
					<div class="col-acciones">Acciones</div>
				</div>

				<!-- Grupos y líneas para MAQUINAS -->
				<template v-if="propuesta.tipo === 'MAQUINAS'">
					<div
						v-for="grupo in grupos"
						:key="grupo.id"
						class="grupo-section"
						:class="`grupo-${grupo.codigo.toLowerCase()}`"
					>
					<!-- Título del grupo -->
					<div
						class="grupo-header"
						@click="toggleGrupo(grupo.id)"
						:class="{'grupo-collapsed': !grupo.visible}"
					>
						<i :class="grupo.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
						<span class="grupo-nombre">{{ grupo.nombre }} ({{ contarLineasGrupo(grupo) }})</span>
					</div>

					<!-- Líneas del grupo (máximo 15) -->
					<template v-if="grupo.visible">
						<div
							v-for="(linea, index) in grupo.lineasVisibles"
							:key="`${grupo.id}-${index}`"
							class="table-row"
							:class="{'row-empty': !linea.referencia && !linea.equipo, 'row-con-documento': linea.tieneDocumento}"
							:data-linea="`m-${grupo.id}-${linea.posicion}`"
						>
							<div class="col-posicion">{{ linea.posicion }}</div>
							<div class="col-referencia">
								<el-input
									v-model="linea.referencia"
									:placeholder="linea.esCatalogado ? 'Código artículo' : 'Referencia'"
									size="small"
									maxlength="18"
									:disabled="linea.esCatalogado"
									@input="onReferenciaChange(grupo.id, index)"
								/>
							</div>
							<div class="col-equipo">
								<div class="equipo-input-wrap">
									<el-autocomplete
										v-if="grupo.tieneArticulos"
										v-model="linea.equipo"
										:fetch-suggestions="(query, cb) => buscarArticulos(query, grupo.id, cb)"
										placeholder="Buscar artículo o escribir..."
										size="small"
										value-key="DESCRIPCION"
										@select="(articulo) => seleccionarArticulo(articulo, grupo.id, index)"
										@input="onEquipoChange(grupo.id, index)"
										style="width: 100%"
									>
										<template slot-scope="{ item }">
											<div>
												<div><strong>{{ item.CODIGO }}</strong> - {{ item.DESCRIPCION }}</div>
											</div>
										</template>
									</el-autocomplete>
									<el-input
										v-else
										v-model="linea.equipo"
										placeholder="Equipo (Modelo, SN,_)"
										size="small"
										@input="onEquipoChange(grupo.id, index)"
									/>
								</div>
								<div
									class="talla-inline"
									v-if="((linea.tipoTallaje || '').toString().toLowerCase() === 'calzado' && (linea.tallas_calzado || []).length) || ((linea.tipoTallaje || '').toString().toLowerCase() === 'ropa' && (linea.tallas_ropa || []).length)"
								>
									<el-select
										v-if="(linea.tipoTallaje || '').toString().toLowerCase() === 'calzado' && (linea.tallas_calzado || []).length"
										v-model="linea.talla"
										placeholder="Seleccione talla"
										filterable
										style="width: 100%"
										size="small"
										@change="actualizarLinea(grupo.id, index)"
									>
										<el-option
											v-for="t in (linea.tallas_calzado || [])"
											:key="t.value || t.text || String(t)"
											:label="t.text || t.__title || t.label || String(t.value || '')"
											:value="t.value || t"
										/>
									</el-select>
									<el-select
										v-else-if="(linea.tipoTallaje || '').toString().toLowerCase() === 'ropa' && (linea.tallas_ropa || []).length"
										v-model="linea.talla"
										placeholder="Seleccione talla"
										filterable
										style="width: 100%"
										size="small"
										@change="actualizarLinea(grupo.id, index)"
									>
										<el-option
											v-for="t in (linea.tallas_ropa || [])"
											:key="t.value || t.text || String(t)"
											:label="t.text || t.__title || t.label || String(t.value || '')"
											:value="t.value || t"
										/>
									</el-select>
								</div>
							</div>
							<div class="col-cantidad">
								<el-input
									v-model="linea.cantidad"
									placeholder="0"
									size="small"
									type="number"
									:min="1"
									:class="{ 'cantidad-pedido-invalida': isCantidadPedidoInvalida(linea) }"
									@input="onCantidadPedidoInput(linea, () => actualizarLinea(grupo.id, index))"
									@blur="validarCantidadPedidoEnLinea(linea)"
								/>
								<div
									v-if="getTextoConversionInformativa(linea)"
									class="conversion-info"
								>
									{{ getTextoConversionInformativa(linea) }}
								</div>
							</div>
							<div class="col-unidad">
								<el-select
									v-if="tieneConversionesUnidad(linea)"
									v-model="linea.unidadSelector"
									placeholder="Unidad"
									size="small"
									filterable
									style="width: 100%"
									@change="(val) => onUnidadSelectorChange(grupo.id, index, val)"
								>
									<el-option
										v-for="opt in getOpcionesUnidad(linea)"
										:key="opt.value"
										:label="opt.label"
										:value="opt.value"
									/>
								</el-select>
								<el-input
									v-if="!tieneConversionesUnidad(linea)"
									v-model="linea.unidad"
									placeholder="Unidad"
									size="small"
									@input="actualizarLinea(grupo.id, index)"
								/>
							</div>
							<div class="col-notas">
								<el-input
									v-model="linea.notas"
									placeholder="Notas BARCO"
									size="small"
									@input="actualizarLinea(grupo.id, index)"
								/>
							</div>
							<div class="col-acciones">
								<el-tooltip v-if="linea.tieneDocumento" content="Documento asociado" placement="top">
									<i class="el-icon-document indicador-documento"></i>
								</el-tooltip>
								<el-tooltip
									v-if="!propuesta.id"
									content="Guarde la propuesta antes de subir documentos"
									placement="top"
								>
									<span>
										<el-button
											type="primary"
											size="mini"
											icon="el-icon-upload"
											:disabled="true"
										>
											Subir Doc.
										</el-button>
									</span>
								</el-tooltip>
								<el-button
									v-else
									type="primary"
									size="mini"
									icon="el-icon-upload"
									@click="abrirSubirDocumentoLinea(linea, grupo)"
								>
									Subir Doc.
								</el-button>
								<el-button
									type="danger"
									size="mini"
									icon="el-icon-delete"
									@click="confirmarEliminarLinea(linea, grupo)"
								>
									Eliminar
								</el-button>
							</div>
						</div>
						<!-- Botón para añadir más líneas -->
						<div v-if="puedeAñadirLineaEnGrupoMaquinas(grupo)" class="add-line-button">
							<el-button
								type="text"
								icon="el-icon-plus"
								@click="añadirLinea(grupo.id)"
								:disabled="!puedeAñadirLineaEnGrupoMaquinas(grupo)"
							>
								Añadir línea ({{ contarLineasGrupo(grupo) }}/{{ maxLineasPorSeccion }})
							</el-button>
						</div>
					</template>
					</div>
				</template>

				<!-- Secciones y grupos para PUENTE -->
				<template v-if="propuesta.tipo === 'PUENTE'">
					<div
						v-for="seccion in secciones"
						:key="seccion.id"
						class="seccion-section"
						:class="`seccion-${seccion.nombre.toLowerCase()}`"
					>
						<!-- Título de la sección -->
						<div
							class="seccion-header"
							@click="toggleSeccion(seccion.id)"
							:class="{'seccion-collapsed': !seccion.visible}"
						>
							<i :class="seccion.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
							<span class="seccion-nombre">{{ seccion.nombre }} ({{ contarLineasSeccion(seccion) }})</span>
						</div>

						<!-- Grupos de la sección -->
						<template v-if="seccion.visible">
							<div
								v-for="grupo in seccion.grupos"
								:key="grupo.id"
								class="grupo-section"
								:class="`grupo-${grupo.codigo.toLowerCase()}`"
							>
								<!-- Título del grupo -->
								<div
									class="grupo-header"
									@click="toggleGrupoPuente(seccion.id, grupo.id)"
									:class="{'grupo-collapsed': !grupo.visible}"
								>
									<i :class="grupo.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
									<span class="grupo-nombre">{{ grupo.nombre }} ({{ contarLineasGrupo(grupo) }})</span>
								</div>

								<!-- Líneas del grupo (máximo 15) -->
								<template v-if="grupo.visible">
									<div
										v-for="(linea, index) in grupo.lineasVisibles"
										:key="`${seccion.id}-${grupo.id}-${index}`"
										class="table-row"
										:class="{'row-empty': !linea.referencia && !linea.equipo, 'row-con-documento': linea.tieneDocumento}"
										:data-linea="`p-${seccion.id}-${grupo.id}-${linea.posicion}`"
									>
									<div class="col-posicion">{{ linea.posicion }}</div>
									<div class="col-referencia">
										<el-input
											v-model="linea.referencia"
											:placeholder="linea.esCatalogado ? 'Código artículo' : 'Referencia'"
											size="small"
											maxlength="18"
											:disabled="linea.esCatalogado"
											@input="onReferenciaChangePuente(seccion.id, grupo.id, index)"
										/>
									</div>
									<div class="col-equipo">
										<div class="equipo-input-wrap">
											<el-autocomplete
												v-if="grupo.tieneArticulos"
												v-model="linea.equipo"
												:fetch-suggestions="(query, cb) => buscarArticulos(query, grupo.id, cb)"
												placeholder="Buscar artículo o escribir..."
												size="small"
												value-key="DESCRIPCION"
												@select="(articulo) => seleccionarArticuloPuente(articulo, seccion.id, grupo.id, index)"
												@input="onEquipoChangePuente(seccion.id, grupo.id, index)"
												style="width: 100%"
											>
												<template slot-scope="{ item }">
													<div>
														<div><strong>{{ item.CODIGO }}</strong> - {{ item.DESCRIPCION }}</div>
													</div>
												</template>
											</el-autocomplete>
											<el-input
												v-else
												v-model="linea.equipo"
												placeholder="Equipo (Modelo, SN,_)"
												size="small"
												@input="onEquipoChangePuente(seccion.id, grupo.id, index)"
											/>
										</div>
							<div
								class="talla-inline"
								v-if="((linea.tipoTallaje || '').toString().toLowerCase() === 'calzado' && (linea.tallas_calzado || []).length) || ((linea.tipoTallaje || '').toString().toLowerCase() === 'ropa' && (linea.tallas_ropa || []).length)"
							>
								<el-select
									v-if="(linea.tipoTallaje || '').toString().toLowerCase() === 'calzado' && (linea.tallas_calzado || []).length"
									v-model="linea.talla"
									placeholder="Seleccione talla"
									filterable
									style="width: 100%"
									size="small"
									@change="actualizarLineaPuente(seccion.id, grupo.id, index)"
								>
									<el-option
										v-for="t in (linea.tallas_calzado || [])"
										:key="t.value || t.text || String(t)"
										:label="t.text || t.__title || t.label || String(t.value || '')"
										:value="t.value || t"
									/>
								</el-select>
								<el-select
									v-else-if="(linea.tipoTallaje || '').toString().toLowerCase() === 'ropa' && (linea.tallas_ropa || []).length"
									v-model="linea.talla"
									placeholder="Seleccione talla"
									filterable
									style="width: 100%"
									size="small"
									@change="actualizarLineaPuente(seccion.id, grupo.id, index)"
								>
									<el-option
										v-for="t in (linea.tallas_ropa || [])"
										:key="t.value || t.text || String(t)"
										:label="t.text || t.__title || t.label || String(t.value || '')"
										:value="t.value || t"
									/>
								</el-select>
							</div>
									</div>
										<div class="col-cantidad">
											<el-input
												v-model="linea.cantidad"
												placeholder="0"
												size="small"
												type="number"
												:min="1"
												:class="{ 'cantidad-pedido-invalida': isCantidadPedidoInvalida(linea) }"
												@input="onCantidadPedidoInput(linea, () => actualizarLineaPuente(seccion.id, grupo.id, index))"
												@blur="validarCantidadPedidoEnLinea(linea)"
											/>
											<div
												v-if="getTextoConversionInformativa(linea)"
												class="conversion-info"
											>
												{{ getTextoConversionInformativa(linea) }}
											</div>
										</div>
										<div class="col-unidad">
											<el-select
												v-if="tieneConversionesUnidad(linea)"
												v-model="linea.unidadSelector"
												placeholder="Unidad"
												size="small"
												filterable
												style="width: 100%"
												@change="(val) => onUnidadSelectorChangePuente(seccion.id, grupo.id, index, val)"
											>
												<el-option
													v-for="opt in getOpcionesUnidad(linea)"
													:key="opt.value"
													:label="opt.label"
													:value="opt.value"
												/>
											</el-select>
											<el-input
												v-if="!tieneConversionesUnidad(linea)"
												v-model="linea.unidad"
												placeholder="Unidad"
												size="small"
												@input="actualizarLineaPuente(seccion.id, grupo.id, index)"
											/>
										</div>
										<div class="col-notas">
											<el-input
												v-model="linea.notas"
												placeholder="Notas BARCO"
												size="small"
												@input="actualizarLineaPuente(seccion.id, grupo.id, index)"
											/>
										</div>
										<div class="col-acciones">
											<el-tooltip v-if="linea.tieneDocumento" content="Documento asociado" placement="top">
												<i class="el-icon-document indicador-documento"></i>
											</el-tooltip>
											<el-tooltip
												v-if="!propuesta.id"
												content="Guarde la propuesta antes de subir documentos"
												placement="top"
											>
												<span>
													<el-button
														type="primary"
														size="mini"
														icon="el-icon-upload"
														:disabled="true"
													>
														Subir Doc.
													</el-button>
												</span>
											</el-tooltip>
											<el-button
												v-else
												type="primary"
												size="mini"
												icon="el-icon-upload"
												@click="abrirSubirDocumentoLinea(linea, grupo)"
											>
												Subir Doc.
											</el-button>
											<el-button
												type="danger"
												size="mini"
												icon="el-icon-delete"
												@click="confirmarEliminarLinea(linea, grupo)"
											>
												Eliminar
											</el-button>
										</div>
									</div>
									<!-- Botón para añadir más líneas -->
									<div v-if="puedeAñadirLineaEnGrupoPuente(seccion, grupo)" class="add-line-button">
										<el-button
											type="text"
											icon="el-icon-plus"
											@click="añadirLineaPuente(seccion.id, grupo.id)"
											:disabled="!puedeAñadirLineaEnGrupoPuente(seccion, grupo)"
										>
											Añadir línea ({{ contarLineasGrupo(grupo) }}/{{ maxLineasPorSeccion }})
										</el-button>
									</div>
								</template>
							</div>
						</template>
					</div>
				</template>
			</div>
		</div>

		<!-- Modal para subir documento por línea -->
		<el-dialog
			title="Subir Documento (Línea)"
			:visible.sync="modalSubirDocumentoLinea.visible"
			width="500px"
		>
			<el-alert
				v-if="modalSubirDocumentoLinea.tieneDocumentoPrevio"
				title="Esta línea ya tiene un documento asociado. Al subir un nuevo documento se eliminará el anterior."
				type="warning"
				show-icon
				:closable="false"
				style="margin-bottom: 1rem;"
			/>
			<el-form label-width="120px">
				<el-form-item label="Documento:" required>
					<input
						ref="inputFileDocumentoLinea"
						type="file"
						style="display: none"
						@change="onFileSelectedLinea"
						accept="*/*"
					/>
					<el-button type="primary" @click="$refs.inputFileDocumentoLinea.click()">
						<i class="el-icon-upload"></i> Seleccionar Archivo
					</el-button>
					<span v-if="modalSubirDocumentoLinea.archivoSeleccionado" style="margin-left: 10px;">
						{{ modalSubirDocumentoLinea.archivoSeleccionado.name }}
					</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modalSubirDocumentoLinea.visible = false">Cancelar</el-button>
				<el-button
					type="primary"
					@click="subirDocumentoLinea"
					:loading="modalSubirDocumentoLinea.subiendo"
					:disabled="!modalSubirDocumentoLinea.archivoSeleccionado"
				>
					Subir
				</el-button>
			</div>
		</el-dialog>

		<!-- Modal confirmar lanzar propuesta -->
		<el-dialog
			title="Confirmar lanzar propuesta"
			:visible.sync="modalConfirmarLanzar.visible"
			width="560px"
			:close-on-click-modal="false"
		>
			<p class="confirmar-lanzar-mensaje">
				¿Está seguro que desea lanzar la propuesta {{ propuesta.numeroPropuesta }} con las siguientes posiciones?
			</p>
			<div class="confirmar-lanzar-lista">
				<div
					v-for="(item, index) in modalConfirmarLanzar.lineasResumen"
					:key="index"
					class="confirmar-lanzar-linea"
				>
					<span class="confirmar-lanzar-equipo">{{ item.equipo || '—' }}</span>
					<span class="confirmar-lanzar-cantidad">{{ item.cantidad }}</span>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modalConfirmarLanzar.visible = false">No</el-button>
				<el-button type="primary" @click="ejecutarLanzarPropuesta">Sí</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import { getUrl } from '@/helpers/api'

const MAX_LINEAS_POR_SECCION = 15

export default {
  name: 'Propuesta',
  data () {
    return {
      modalInicial: {
        visible: true,
        paso: 1 // 1: nueva/continuar, 2: tipo propuesta, 3: seleccionar existente
      },
      propuesta: {
        id: null,
        buqueId: null,
        buqueNombre: '',
        jMaquinas: '',
        fecha: moment().format('YYYY-MM-DD'),
        numeroPropuesta: '',
        tipo: 'MAQUINAS'
      },
      grupos: [],
      secciones: [], // Para propuestas tipo PUENTE
      listaDestinos: [],
      loadingDestinos: false,
      listaPropuestasPendientes: [],
      loadingPropuestas: false,
      propuestaSeleccionada: null,
      loadingInicial: true, // Estado de carga inicial
      intervaloAutoguardado: null, // Intervalo para el autoguardado
      buscadorArticulosGlobal: {
        texto: ''
      },
      modalSubirDocumentoLinea: {
        visible: false,
        propuestaId: null,
        grupoCodigo: null,
        posicion: null,
        archivoSeleccionado: null,
        subiendo: false,
        tieneDocumentoPrevio: false
      },
      modalConfirmarLanzar: {
        visible: false,
        lineasResumen: [] // { equipo, cantidad }
      },
      maxLineasPorSeccion: MAX_LINEAS_POR_SECCION
    }
  },
  watch: {
    'propuesta.buqueId' (newId) {
      if (newId) {
        const destinoSeleccionado = this.listaDestinos.find(d => d.IDDESTINOS === newId)
        if (destinoSeleccionado) {
          this.propuesta.buqueNombre = destinoSeleccionado.DESTINO
        }
      } else {
        this.propuesta.buqueNombre = ''
      }
    }
  },
  async created () {
    // Mostrar modal con "Cargando..." mientras se cargan las peticiones
    this.modalInicial.visible = true
    // Al cargar, consultar las propuestas disponibles
    await this.consultarPropuestasDisponibles()
    // Finalizar carga inicial
    this.loadingInicial = false
  },
  mounted () {
    // Iniciar el autoguardado cada 5 minutos (300000 ms)
    this.iniciarAutoguardado()
  },
  beforeDestroy () {
    // Limpiar el intervalo cuando se destruya el componente
    if (this.intervaloAutoguardado) {
      clearInterval(this.intervaloAutoguardado)
      this.intervaloAutoguardado = null
    }
  },
  methods: {
    limitarReferencia (val) {
      const s = val != null ? String(val) : ''
      return s.length > 18 ? s.slice(0, 18) : s
    },
    async consultarPropuestasDisponibles () {
      try {
        this.loadingPropuestas = true
        const endpoints = getUrl()
        if (!endpoints) {
          console.error('Endpoints no disponibles')
          this.$message.error('Error de configuración')
          return
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/listarPropuestasPendientes`,
          { tipo: null } // null para obtener todas
        )

        // Procesar la respuesta
        let propuestas = []
        let tipoPermitido = null

        if (response.data) {
          // Si hay un array de propuestas
          if (Array.isArray(response.data)) {
            propuestas = response.data
          } else if (response.data.data && Array.isArray(response.data.data)) {
            propuestas = response.data.data
          }

          // Si no hay propuestas, el backend puede devolver un campo 'tipo' con los permisos
          // El campo 'tipo' puede estar en response.data.tipo o en response.data.data.tipo
          if (propuestas.length === 0) {
            if (response.data.tipo) {
              tipoPermitido = response.data.tipo
            } else if (response.data.data && response.data.data.tipo) {
              tipoPermitido = response.data.data.tipo
            }
          }
        }

        // Lógica según el resultado
        if (propuestas.length > 1) {
          // Múltiples propuestas: mostrar select
          this.listaPropuestasPendientes = propuestas
          // El modal ya está visible con "Cargando...", cambiar al paso 3 cuando termine
          this.modalInicial.paso = 3
        } else if (propuestas.length === 1) {
          // Una sola propuesta: cargarla directamente
          // Las peticiones de grupos y destinos se harán dentro de cargarPropuestaSeleccionada
          await this.cargarPropuestaSeleccionada(propuestas[0].id)
          // El modal se ocultará dentro de cargarPropuestaSeleccionada
        } else {
          // No hay propuestas: según el tipo permitido
          if (tipoPermitido === 'MAQUINAS') {
            // Entrar directamente a nueva de MAQUINAS
            this.propuesta.tipo = 'MAQUINAS'
            // Cargar grupos y destinos (estas peticiones se mostrarán con "Cargando...")
            await this.inicializarGrupos()
            await this.cargarDestinos()
            // Ocultar modal después de cargar
            this.modalInicial.visible = false
            this.$nextTick(() => this.mostrarAvisoPropuestaAbierta(false))
          } else if (tipoPermitido === 'PUENTE') {
            // Entrar directamente a nueva de PUENTE
            this.propuesta.tipo = 'PUENTE'
            // Cargar grupos y destinos (estas peticiones se mostrarán con "Cargando...")
            await this.inicializarGrupos()
            await this.cargarDestinos()
            // Ocultar modal después de cargar
            this.modalInicial.visible = false
            this.$nextTick(() => this.mostrarAvisoPropuestaAbierta(false))
          } else {
            // tipoPermitido === 'TODOS' o no especificado: mostrar modal para elegir
            // El modal ya está visible con "Cargando...", cambiar al paso 2 cuando termine
            this.modalInicial.paso = 2
          }
        }
      } catch (error) {
        console.error('Error al consultar propuestas disponibles:', error)
        this.$message.error('Error al consultar las propuestas disponibles')
        // En caso de error, mostrar modal para elegir tipo
        // El modal ya está visible con "Cargando...", cambiar al paso 2 cuando termine
        this.modalInicial.paso = 2
      } finally {
        this.loadingPropuestas = false
      }
    },
    async cargarDestinos () {
      // Evitar cargar múltiples veces si ya se cargó
      if (this.listaDestinos.length > 0) return

      try {
        this.loadingDestinos = true
        const endpoints = getUrl()
        if (!endpoints) {
          console.error('Endpoints no disponibles')
          return
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/destinos/buscador/listarDestinos`,
          {}
        )

        // La respuesta es un array directo con la estructura:
        // [{ IDDESTINOS, DESTINO, COD, CONT, estado, created_at, updated_at }, ...]
        if (Array.isArray(response.data)) {
          this.listaDestinos = response.data.map(item => ({
            IDDESTINOS: item.IDDESTINOS,
            DESTINO: item.DESTINO,
            COD: item.COD,
            CONT: item.CONT,
            estado: item.estado
          }))
        } else if (response.data && Array.isArray(response.data.data)) {
          // Por si acaso viene envuelto en un objeto data
          this.listaDestinos = response.data.data.map(item => ({
            IDDESTINOS: item.IDDESTINOS,
            DESTINO: item.DESTINO,
            COD: item.COD,
            CONT: item.CONT,
            estado: item.estado
          }))
        } else {
          this.listaDestinos = []
        }

        // Si hay un buque seleccionado, actualizar el nombre
        if (this.propuesta.buqueId) {
          const destinoSeleccionado = this.listaDestinos.find(d => d.IDDESTINOS === this.propuesta.buqueId)
          if (destinoSeleccionado) {
            this.propuesta.buqueNombre = destinoSeleccionado.DESTINO
          }
        }
      } catch (error) {
        console.error('Error al cargar destinos:', error)
        this.$message.error('Error al cargar la lista de buques')
        this.listaDestinos = []
      } finally {
        this.loadingDestinos = false
      }
    },
    async inicializarGrupos () {
      await this.cargarGruposDesdeBackend()
    },
    async cargarGruposDesdeBackend () {
      try {
        const endpoints = getUrl()
        if (!endpoints) {
          console.error('Endpoints no disponibles')
          this.$message.error('Error de configuración')
          return
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/listarSecciones`,
          { tipo: this.propuesta.tipo }
        )

        // Procesar la respuesta según el tipo
        let data = []
        if (response.data && response.data.data) {
          data = response.data.data
        } else if (Array.isArray(response.data)) {
          data = response.data
        }

        if (this.propuesta.tipo === 'PUENTE') {
          this.inicializarGruposPuente(data)
        } else {
          this.inicializarGruposMaquinas(data)
        }
      } catch (error) {
        console.error('Error al cargar grupos desde el backend:', error)
        this.$message.error('Error al cargar los grupos. Por favor, intente nuevamente.')
      }
    },
    inicializarGruposMaquinas (gruposBackend) {
      if (!gruposBackend || !Array.isArray(gruposBackend) || gruposBackend.length === 0) {
        console.warn('No se recibieron grupos desde el backend para MAQUINAS')
        return
      }

      let posicionGlobal = 1
      this.grupos = gruposBackend.map((grupo) => {
        // Crear 15 líneas vacías por grupo
        const lineas = []
        for (let i = 1; i <= 15; i++) {
          lineas.push({
            posicion: posicionGlobal++,
            referencia: '',
            equipo: '',
            cantidad: '',
            unidad: '',
            unidadBase: '',
            // conversiones disponibles para que el backend aplique CANTIDAD*factor
            articulo_conversion: [],
            // valor seleccionado en el selector de unidad (solo aplica si hay conversiones)
            unidadSelector: '',
            talla: '',
            tipoTallaje: '',
            tallas_calzado: [],
            tallas_ropa: [],
            notas: '',
            estado: 'PENDIENTE',
            busquedaArticulo: '', // Campo para la búsqueda de artículos
            idArticulo: null, // ID del artículo catalogado (null si no catalogado)
            esCatalogado: false, // Indica si el artículo viene del catálogo
            descripcionArticuloOriginal: '', // Descripción original del artículo seleccionado
            idLineaPropuesta: null, // ID de la línea de propuesta en backend
            tieneDocumento: false // true si la línea tiene un archivo asociado (viene de backend o tras subir)
          })
        }
        // Mostrar solo las primeras 3 líneas por defecto
        const lineasVisibles = lineas.slice(0, 3)
        return {
          id: grupo.id,
          codigo: grupo.codigo,
          nombre: grupo.nombre,
          color: grupo.color,
          tieneArticulos: grupo.tieneArticulos || false, // Indica si el grupo tiene artículos asociados
          lineas: lineas,
          lineasVisibles: lineasVisibles,
          visible: false // Grupos cerrados por defecto en nuevas propuestas
        }
      })
      this.secciones = [] // Limpiar secciones para MAQUINAS
    },
    inicializarGruposPuente (seccionesBackend) {
      if (!seccionesBackend || !Array.isArray(seccionesBackend) || seccionesBackend.length === 0) {
        console.warn('No se recibieron secciones desde el backend para PUENTE')
        return
      }

      let posicionGlobal = 1

      const crearGruposConLineas = (grupos) => {
        return grupos.map((grupo) => {
          const lineas = []
          for (let i = 1; i <= 15; i++) {
            lineas.push({
              posicion: posicionGlobal++,
              referencia: '',
              equipo: '',
              cantidad: '',
              unidad: '',
              unidadBase: '',
              articulo_conversion: [],
              unidadSelector: '',
              talla: '',
              tipoTallaje: '',
              tallas_calzado: [],
              tallas_ropa: [],
              notas: '',
              estado: 'PENDIENTE',
              busquedaArticulo: '', // Campo para la búsqueda de artículos
              idArticulo: null, // ID del artículo catalogado (null si no catalogado)
              esCatalogado: false, // Indica si el artículo viene del catálogo
              idLineaPropuesta: null, // ID de la línea de propuesta en backend
              tieneDocumento: false
            })
          }
          const lineasVisibles = lineas.slice(0, 3)
          return {
            id: grupo.id,
            codigo: grupo.codigo,
            nombre: grupo.nombre,
            color: grupo.color,
            tieneArticulos: grupo.tieneArticulos || false, // Indica si el grupo tiene artículos asociados
            lineas: lineas,
            lineasVisibles: lineasVisibles,
            visible: false // Grupos cerrados por defecto en nuevas propuestas
          }
        })
      }

      this.secciones = seccionesBackend.map((seccion) => {
        return {
          id: seccion.id,
          nombre: seccion.nombre,
          grupos: crearGruposConLineas(seccion.grupos || []),
          visible: false // Secciones cerradas por defecto en nuevas propuestas
        }
      })
      this.grupos = [] // Limpiar grupos para PUENTE
    },
    añadirLinea (grupoId) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (!grupo) return
      if (!this.puedeAñadirLineaEnGrupoMaquinas(grupo)) {
        this.$message.warning(`No se pueden añadir más de ${MAX_LINEAS_POR_SECCION} líneas en este grupo`)
        return
      }
      const siguienteIndice = grupo.lineasVisibles.length
      grupo.lineasVisibles.push(grupo.lineas[siguienteIndice])
    },
    añadirLineaPuente (seccionId, grupoId) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (!seccion) return
      const grupo = seccion.grupos.find(g => g.id === grupoId)
      if (!grupo) return
      if (!this.puedeAñadirLineaEnGrupoPuente(seccion, grupo)) {
        this.$message.warning(`No se pueden añadir más de ${MAX_LINEAS_POR_SECCION} líneas en el grupo ${grupo.nombre}`)
        return
      }
      const siguienteIndice = grupo.lineasVisibles.length
      grupo.lineasVisibles.push(grupo.lineas[siguienteIndice])
    },
    toggleGrupo (grupoId) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (grupo) {
        grupo.visible = !grupo.visible
      }
    },
    toggleGrupoPuente (seccionId, grupoId) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (seccion) {
        const grupo = seccion.grupos.find(g => g.id === grupoId)
        if (grupo) {
          grupo.visible = !grupo.visible
        }
      }
    },
    toggleSeccion (seccionId) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (seccion) {
        seccion.visible = !seccion.visible
      }
    },
    contarLineasGrupo (grupo) {
      // Contar líneas que tengan referencia o equipo (líneas con datos)
      return grupo.lineas.filter(linea => this.lineaTieneDatos(linea)).length
    },
    contarLineasSeccion (seccion) {
      // Sumar el total de líneas de todos los grupos de la sección
      return seccion.grupos.reduce((total, grupo) => {
        return total + this.contarLineasGrupo(grupo)
      }, 0)
    },
    lineaTieneDatos (linea) {
      return !!(linea && ((linea.referencia && String(linea.referencia).trim()) || (linea.equipo && String(linea.equipo).trim())))
    },
    grupoAlcanzoMaximoLineas (grupo) {
      return this.contarLineasGrupo(grupo) >= MAX_LINEAS_POR_SECCION
    },
    puedeAñadirLineaEnGrupoMaquinas (grupo) {
      if (!grupo) return false
      return !this.grupoAlcanzoMaximoLineas(grupo) && grupo.lineasVisibles.length < grupo.lineas.length
    },
    puedeAñadirLineaEnGrupoPuente (seccion, grupo) {
      return this.puedeAñadirLineaEnGrupoMaquinas(grupo)
    },
    puedeRellenarLineaVacia (linea, grupo) {
      if (!linea || !grupo) return false
      if (this.lineaTieneDatos(linea)) return true
      return !this.grupoAlcanzoMaximoLineas(grupo)
    },
    revertirSiExcedeLimiteLinea (linea, snapshot, grupo) {
      const teniaDatos = this.lineaTieneDatos(snapshot)
      if (teniaDatos || !this.lineaTieneDatos(linea)) return true
      const excede = this.contarLineasGrupo(grupo) > MAX_LINEAS_POR_SECCION
      if (!excede) return true
      linea.referencia = snapshot.referencia || ''
      linea.equipo = snapshot.equipo || ''
      this.$message.warning(`No se pueden añadir más de ${MAX_LINEAS_POR_SECCION} líneas en el grupo ${grupo.nombre}`)
      return false
    },
    validarMaximoLineasPorSeccion (silencioso = false) {
      const grupos = this.propuesta.tipo === 'PUENTE'
        ? this.secciones.flatMap(seccion => seccion.grupos || [])
        : this.grupos
      for (const grupo of grupos) {
        const total = this.contarLineasGrupo(grupo)
        if (total > MAX_LINEAS_POR_SECCION) {
          if (!silencioso) {
            this.$message.error(`El grupo "${grupo.nombre}" tiene ${total} líneas. El máximo permitido es ${MAX_LINEAS_POR_SECCION}.`)
          }
          return false
        }
      }
      return true
    },
    normalizarLimitesLineas (mostrarAviso = true) {
      let recortado = false
      const grupos = this.propuesta.tipo === 'PUENTE'
        ? this.secciones.flatMap(seccion => seccion.grupos || [])
        : this.grupos
      grupos.forEach(grupo => {
        const conDatos = (grupo.lineas || []).filter(linea => this.lineaTieneDatos(linea))
        if (conDatos.length > MAX_LINEAS_POR_SECCION) {
          recortado = true
          conDatos
            .sort((a, b) => Number(a.posicion) - Number(b.posicion))
            .slice(MAX_LINEAS_POR_SECCION)
            .forEach(linea => this.limpiarLinea(linea))
          if (mostrarAviso) {
            this.$message.warning(`El grupo "${grupo.nombre}" superaba el máximo de ${MAX_LINEAS_POR_SECCION} líneas. Se han conservado solo las primeras.`)
          }
        }
        this.sincronizarLineasVisiblesGrupo(grupo)
      })
      return recortado
    },
    sincronizarLineasVisiblesGrupo (grupo) {
      if (!grupo) return
      const visibles = (grupo.lineas || []).filter(linea => this.lineaTieneDatos(linea))
      grupo.lineasVisibles = visibles.length
        ? visibles.slice(0, MAX_LINEAS_POR_SECCION)
        : (grupo.lineas || []).slice(0, Math.min(3, grupo.lineas.length))
    },
    obtenerLineasConDatosParaTallaje () {
      const lineas = []
      if (this.propuesta.tipo === 'PUENTE') {
        for (const seccion of this.secciones) {
          for (const grupo of seccion.grupos || []) {
            for (const linea of grupo.lineasVisibles || []) {
              if (linea && (linea.referencia || linea.equipo)) lineas.push(linea)
            }
          }
        }
      } else {
        for (const grupo of this.grupos || []) {
          for (const linea of grupo.lineasVisibles || []) {
            if (linea && (linea.referencia || linea.equipo)) lineas.push(linea)
          }
        }
      }
      return lineas
    },
    validarTallajeForzado () {
      if (this.hayTallajeForzadoIncompleto()) {
        this.$message.warning('Debe seleccionar la talla en las líneas con tallaje (Calzado/Ropa).')
        return false
      }
      return true
    },
    lineaTieneDatosPedido (linea) {
      if (!linea) return false
      return !!(String(linea.referencia || '').trim() || String(linea.equipo || '').trim())
    },
    parseCantidadDecimal (valor) {
      const txt = String(valor != null ? valor : '').trim()
      if (!txt) return null
      const num = parseFloat(txt.replace(',', '.'))
      return Number.isFinite(num) ? num : null
    },
    esCantidadPedidoValida (cantidad) {
      const txt = String(cantidad != null ? cantidad : '').trim()
      if (!txt || txt.endsWith(',')) return false
      const num = this.parseCantidadDecimal(cantidad)
      return num !== null && num > 0
    },
    isCantidadPedidoInvalida (linea) {
      if (!this.lineaTieneDatosPedido(linea)) return false
      return !this.esCantidadPedidoValida(linea.cantidad)
    },
    hayCantidadesPedidoInvalidas () {
      return this.obtenerLineasConDatosParaTallaje().some(linea => this.isCantidadPedidoInvalida(linea))
    },
    validarCantidadesPedido () {
      const faltantes = []
      this.obtenerLineasConDatosParaTallaje().forEach(linea => {
        if (this.isCantidadPedidoInvalida(linea)) {
          faltantes.push({ posicion: linea.posicion })
        }
      })

      if (!faltantes.length) return true

      const posiciones = faltantes.slice(0, 8).map(i => i.posicion).join(', ')
      const sufijo = faltantes.length > 8 ? `… (+${faltantes.length - 8})` : ''
      this.$message.error(`Falta indicar la cantidad en las líneas del pedido (debe ser superior a 0). Posiciones: ${posiciones}${sufijo}`)
      return false
    },
    filtrarCantidadPedido (linea) {
      if (!linea || linea.cantidad === '' || linea.cantidad === null || linea.cantidad === undefined) return
      const num = this.parseCantidadDecimal(linea.cantidad)
      if (num !== null && num <= 0) {
        this.$message.warning('La cantidad debe ser superior a 0')
        this.$set(linea, 'cantidad', '')
      }
    },
    validarCantidadPedidoEnLinea (linea) {
      if (!linea || !this.lineaTieneDatosPedido(linea)) return true
      if (!this.isCantidadPedidoInvalida(linea)) return true
      const num = this.parseCantidadDecimal(linea.cantidad)
      if (num !== null && num <= 0) {
        this.$message.warning('La cantidad debe ser superior a 0')
        this.$set(linea, 'cantidad', '')
      }
      return false
    },
    onCantidadPedidoInput (linea, syncFn) {
      this.filtrarCantidadPedido(linea)
      if (typeof syncFn === 'function') syncFn()
    },
    hayTallajeForzadoIncompleto () {
      const lineas = this.obtenerLineasConDatosParaTallaje()
      for (const linea of lineas) {
        const tipoTallaje = (linea.tipoTallaje || '').toString().trim().toLowerCase()
        if (tipoTallaje === 'calzado') {
          const opciones = Array.isArray(linea.tallas_calzado) ? linea.tallas_calzado : []
          if (opciones.length > 0 && (linea.talla == null || linea.talla.toString().trim() === '')) return true
        } else if (tipoTallaje === 'ropa') {
          const opciones = Array.isArray(linea.tallas_ropa) ? linea.tallas_ropa : []
          if (opciones.length > 0 && (linea.talla == null || linea.talla.toString().trim() === '')) return true
        }
      }
      return false
    },
    async buscarArticulosGlobal (query, callback) {
      try {
        const endpoints = getUrl()
        if (!endpoints) {
          callback([])
          return
        }

        const payloadBase = {}
        if (query && query.trim() !== '') {
          payloadBase.descripcion = query.trim()
        }

        const peticiones = []
        // MAQUINAS: grupos en this.grupos
        if (this.propuesta.tipo !== 'PUENTE') {
          this.grupos
            .filter(grupo => grupo.tieneArticulos)
            .forEach(grupo => {
              const payload = Object.assign({ id: grupo.id }, payloadBase)
              const p = axios.post(
                `${endpoints.backend}entidad/articulos/buscador/listarArticulosSeccion`,
                payload
              ).then(resp => ({ resp, grupo }))
              peticiones.push(p)
            })
        } else {
          // PUENTE: secciones y grupos
          this.secciones.forEach(seccion => {
            seccion.grupos
              .filter(grupo => grupo.tieneArticulos)
              .forEach(grupo => {
                const payload = Object.assign({ id: grupo.id }, payloadBase)
                const p = axios.post(
                  `${endpoints.backend}entidad/articulos/buscador/listarArticulosSeccion`,
                  payload
                ).then(resp => ({ resp, grupo, seccion }))
                peticiones.push(p)
              })
          })
        }

        if (!peticiones.length) {
          callback([])
          return
        }

        const resultadosBrutos = await Promise.all(peticiones)
        const mapaPorId = new Map()

        resultadosBrutos.forEach(({ resp, grupo, seccion }) => {
          let articulos = []
          let tallasCalzado = []
          let tallasRopa = []

          // Nuevo formato: resp.data = { articulos: [...], tallas_calzado: [...], tallas_ropa: [...] }
          // Formatos antiguos: resp.data es array directo o resp.data.data es array
          if (Array.isArray(resp.data)) {
            articulos = resp.data
          } else if (resp.data && Array.isArray(resp.data.data)) {
            articulos = resp.data.data
          } else if (resp.data && Array.isArray(resp.data.articulos)) {
            articulos = resp.data.articulos
            tallasCalzado = Array.isArray(resp.data.tallas_calzado) ? resp.data.tallas_calzado : []
            tallasRopa = Array.isArray(resp.data.tallas_ropa) ? resp.data.tallas_ropa : []
          } else if (resp.data && resp.data.data && Array.isArray(resp.data.data.articulos)) {
            articulos = resp.data.data.articulos
            tallasCalzado = Array.isArray(resp.data.data.tallas_calzado) ? resp.data.data.tallas_calzado : []
            tallasRopa = Array.isArray(resp.data.data.tallas_ropa) ? resp.data.data.tallas_ropa : []
          }
          articulos.forEach(articulo => {
            const idClave = articulo.IDARTICULOS || articulo.CODIGO || articulo.DESCRIPCION
            if (!idClave) return
            if (!mapaPorId.has(idClave)) {
              mapaPorId.set(idClave, Object.assign({}, articulo, {
                __grupoId: grupo.id,
                __grupoNombre: grupo.nombre,
                __seccionId: seccion ? seccion.id : null,
                __seccionNombre: seccion ? seccion.nombre : null,
                __tallas_calzado: tallasCalzado,
                __tallas_ropa: tallasRopa
              }))
            } else {
              // Si ya existe, aseguramos que tenga las opciones de tallaje del último payload
              const existente = mapaPorId.get(idClave)
              if (existente) {
                existente.__tallas_calzado = tallasCalzado
                existente.__tallas_ropa = tallasRopa
              }
            }
          })
        })

        const resultados = Array.from(mapaPorId.values()).map(art => ({
          ...art,
          value: art.DESCRIPCION || '',
          __infoGrupo: this.propuesta.tipo === 'PUENTE'
            ? `${art.__seccionNombre || ''} - ${art.__grupoNombre || ''}`
            : art.__grupoNombre || ''
        }))

        callback(resultados)
      } catch (error) {
        console.error('Error en buscarArticulosGlobal:', error)
        callback([])
      }
    },
    seleccionarArticuloGlobal (articulo) {
      try {
        if (!articulo || !articulo.__grupoId) return

        const idArticulo = articulo.IDARTICULOS || null
        const codigo = (articulo.CODIGO || '').toString().trim()
        const descripcion = (articulo.DESCRIPCION || articulo.value || '').toString().trim()

        const normalizar = (v) => (v || '').toString().trim().toLowerCase()
        const coincidePorIdArticulo = (linea) => {
          if (!linea || linea.idArticulo == null || idArticulo == null) return false
          const a = Number(linea.idArticulo)
          const b = Number(idArticulo)
          if (!isNaN(a) && !isNaN(b)) return a === b
          return String(linea.idArticulo) === String(idArticulo)
        }
        const coincidePorTexto = (linea) => {
          // Cuando la línea fue añadida/editada localmente pero no guardada, puede no tener idArticulo aún.
          // En ese caso intentamos localizarla por referencia (código) o por descripción.
          if (!linea) return false
          if (codigo && normalizar(linea.referencia) === normalizar(codigo)) return true
          if (descripcion && normalizar(linea.equipo) === normalizar(descripcion)) return true
          if (descripcion && normalizar(linea.descripcionArticuloOriginal) === normalizar(descripcion)) return true
          return false
        }

        const asegurarVisible = (grupo, linea, seccion = null) => {
          if (!grupo || !linea) return
          const posLinea = Number(linea.posicion)
          const idLinea = linea.idLineaPropuesta != null ? Number(linea.idLineaPropuesta) : null
          const yaVisible = (grupo.lineasVisibles || []).some(lv => {
            if (!lv) return false
            const idVisible = lv.idLineaPropuesta != null ? Number(lv.idLineaPropuesta) : null
            if (idLinea != null && idVisible != null && !isNaN(idLinea) && !isNaN(idVisible)) {
              return idVisible === idLinea
            }
            return Number(lv.posicion) === posLinea
          })
          if (yaVisible) return
          const puedeAñadir = seccion
            ? this.puedeAñadirLineaEnGrupoPuente(seccion, grupo)
            : this.puedeAñadirLineaEnGrupoMaquinas(grupo)
          if (!puedeAñadir) return
          if (grupo.lineasVisibles.length < grupo.lineas.length) {
            grupo.lineasVisibles.push(linea)
          }
        }
        const getIndiceVisible = (grupo, linea) => {
          if (!grupo || !linea) return -1
          const posLinea = Number(linea.posicion)
          const idLinea = linea.idLineaPropuesta != null ? Number(linea.idLineaPropuesta) : null
          return (grupo.lineasVisibles || []).findIndex(lv => {
            if (!lv) return false
            const idVisible = lv.idLineaPropuesta != null ? Number(lv.idLineaPropuesta) : null
            if (idLinea != null && idVisible != null && !isNaN(idLinea) && !isNaN(idVisible)) {
              return idVisible === idLinea
            }
            return Number(lv.posicion) === posLinea
          })
        }

        if (this.propuesta.tipo === 'PUENTE') {
          let seccion = null
          let grupo = null
          let linea = null

          // 1) Priorizar línea ya existente en cualquier grupo/sección.
          for (const s of this.secciones) {
            for (const g of (s.grupos || [])) {
              const existente = g.lineas.find(coincidePorIdArticulo) || g.lineas.find(coincidePorTexto)
              if (existente) {
                seccion = s
                grupo = g
                linea = existente
                break
              }
            }
            if (linea) break
          }

          // 2) Fallback: usar el grupo sugerido por el buscador global.
          if (!linea) {
            seccion = this.secciones.find(s => Number(s.id) === Number(articulo.__seccionId))
            if (!seccion) return
            grupo = seccion.grupos.find(g => Number(g.id) === Number(articulo.__grupoId))
            if (!grupo) return
            if (this.grupoAlcanzoMaximoLineas(grupo)) {
              this.$message.warning(`No se pueden añadir más de ${MAX_LINEAS_POR_SECCION} líneas en el grupo ${grupo.nombre}`)
              return
            }
            linea = grupo.lineas.find(l => !l.referencia && !l.equipo)
          }

          seccion.visible = true
          grupo.visible = true

          if (!linea) {
            this.$message.warning(`No hay líneas disponibles en el grupo ${grupo.nombre}`)
            return
          }

          if (!this.puedeRellenarLineaVacia(linea, grupo)) {
            this.$message.warning(`No se pueden añadir más de ${MAX_LINEAS_POR_SECCION} líneas en el grupo ${grupo.nombre}`)
            return
          }

          asegurarVisible(grupo, linea, seccion)

          const index = getIndiceVisible(grupo, linea)
          if (index === -1) return

          this.seleccionarArticuloPuente(articulo, seccion.id, grupo.id, index)
          this.$nextTick(() => {
            const key = `p-${seccion.id}-${grupo.id}-${linea.posicion}`
            this.scrollALinea(key)
          })
        } else {
          let grupo = null
          let linea = null

          // 1) Priorizar línea existente en cualquier grupo.
          for (const g of this.grupos) {
            const existente = g.lineas.find(coincidePorIdArticulo) || g.lineas.find(coincidePorTexto)
            if (existente) {
              grupo = g
              linea = existente
              break
            }
          }

          // 2) Fallback: grupo sugerido y primera línea vacía.
          if (!linea) {
            grupo = this.grupos.find(g => Number(g.id) === Number(articulo.__grupoId))
            if (!grupo) return
            if (this.grupoAlcanzoMaximoLineas(grupo)) {
              this.$message.warning(`No se pueden añadir más de ${MAX_LINEAS_POR_SECCION} líneas en el grupo ${grupo.nombre}`)
              return
            }
            linea = grupo.lineas.find(l => !l.referencia && !l.equipo)
          }

          grupo.visible = true

          if (!linea) {
            this.$message.warning(`No hay líneas disponibles en el grupo ${grupo.nombre}`)
            return
          }

          if (!this.puedeRellenarLineaVacia(linea, grupo)) {
            this.$message.warning(`No se pueden añadir más de ${MAX_LINEAS_POR_SECCION} líneas en el grupo ${grupo.nombre}`)
            return
          }

          asegurarVisible(grupo, linea)

          const index = getIndiceVisible(grupo, linea)
          if (index === -1) return

          this.seleccionarArticulo(articulo, grupo.id, index)
          this.$nextTick(() => {
            const key = `m-${grupo.id}-${linea.posicion}`
            this.scrollALinea(key)
          })
        }
      } finally {
        // Limpiar texto buscador SIEMPRE (aunque haya returns por no encontrar línea)
        this.buscadorArticulosGlobal.texto = ''
      }
    },
    scrollALinea (dataLineaKey) {
      try {
        const el = this.$el.querySelector(`[data-linea=\"${dataLineaKey}\"]`)
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      } catch (e) {
        console.warn('No se pudo hacer scroll a la línea:', e)
      }
    },
    async buscarArticulos (query, idSeccion, callback) {
      try {
        const endpoints = getUrl()
        if (!endpoints) {
          callback([])
          return
        }

        // Preparar el payload
        const payload = {
          id: idSeccion
        }

        // Si hay query, agregar descripción
        if (query && query.trim() !== '') {
          payload.descripcion = query.trim()
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/articulos/buscador/listarArticulosSeccion`,
          payload
        )

        // Procesar la respuesta
        let articulos = []
        let tallasCalzado = []
        let tallasRopa = []

        // Nuevo formato: response.data = { articulos: [...], tallas_calzado: [...], tallas_ropa: [...] }
        // Formatos antiguos: response.data es array directo o response.data.data es array
        if (Array.isArray(response.data)) {
          articulos = response.data
        } else if (response.data && Array.isArray(response.data.data)) {
          articulos = response.data.data
        } else if (response.data && Array.isArray(response.data.articulos)) {
          articulos = response.data.articulos
          tallasCalzado = Array.isArray(response.data.tallas_calzado) ? response.data.tallas_calzado : []
          tallasRopa = Array.isArray(response.data.tallas_ropa) ? response.data.tallas_ropa : []
        } else if (response.data && response.data.data && Array.isArray(response.data.data.articulos)) {
          articulos = response.data.data.articulos
          tallasCalzado = Array.isArray(response.data.data.tallas_calzado) ? response.data.data.tallas_calzado : []
          tallasRopa = Array.isArray(response.data.data.tallas_ropa) ? response.data.data.tallas_ropa : []
        }

        // Formatear para el autocomplete
        const resultados = articulos.map(articulo => ({
          ...articulo,
          __tallas_calzado: tallasCalzado,
          __tallas_ropa: tallasRopa,
          value: articulo.DESCRIPCION || ''
        }))

        callback(resultados)
      } catch (error) {
        console.error('Error al buscar artículos:', error)
        callback([])
      }
    },
    seleccionarArticulo (articulo, grupoId, index) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (grupo && grupo.lineasVisibles[index]) {
        const linea = grupo.lineasVisibles[index]
        if (!this.puedeRellenarLineaVacia(linea, grupo)) {
          this.$message.warning(`No se pueden añadir más de ${MAX_LINEAS_POR_SECCION} líneas en este grupo`)
          return
        }
        const idArticuloNuevo = articulo.IDARTICULOS || null
        const mismoArticulo =
					linea.idArticulo != null &&
					idArticuloNuevo != null &&
					Number(linea.idArticulo) === Number(idArticuloNuevo)
        const tallaAnterior = linea.talla

        const tipoTallaje = (articulo.TIPO_TALLAJE || articulo.tipoTallaje || articulo.tipo_tallaje || '').toString()
        const tallasCalzado = Array.isArray(articulo.__tallas_calzado) ? articulo.__tallas_calzado : []
        const tallasRopa = Array.isArray(articulo.__tallas_ropa) ? articulo.__tallas_ropa : []

        // Rellenar campos con los datos del artículo catalogado
        linea.referencia = this.limitarReferencia(articulo.CODIGO || '')
        linea.equipo = articulo.DESCRIPCION || ''
        linea.tipoTallaje = tipoTallaje
        linea.tallas_calzado = tallasCalzado
        linea.tallas_ropa = tallasRopa

        // Unidad de medida: el backend calcula conversiones si `linea.unidad` coincide exacto con
        // `articulo.articulo_conversion[].CONVERSION`.
        const conversiones = Array.isArray(articulo.articulo_conversion)
          ? articulo.articulo_conversion
          : (Array.isArray(articulo.articuloConversion) ? articulo.articuloConversion : [])

        linea.articulo_conversion = conversiones

        if (conversiones.length) {
          const unidadBase = this.getUnidadBaseArticulo(articulo)
          linea.unidadBase = unidadBase
          const opciones = this.getOpcionesUnidadDesdeArticulo(articulo, conversiones)
          const unidadPersistida = (articulo.UNIDAD || '').toString().trim()
          const unidadInicial = opciones.some(o => o.value === unidadPersistida) ? unidadPersistida : unidadBase
          linea.unidad = unidadInicial
          linea.unidadSelector = unidadInicial
        } else {
          linea.unidad = (articulo.UNIDAD || '').toString()
          linea.unidadBase = ''
          linea.unidadSelector = ''
        }

        // Conservar talla al re-seleccionar el mismo artículo si sigue siendo válida.
        if (mismoArticulo) {
          const tipoNormalizado = (tipoTallaje || '').toLowerCase()
          if (tipoNormalizado === 'calzado') {
            const permitidas = tallasCalzado.map(t => String(t && t.value != null ? t.value : t))
            linea.talla = permitidas.includes(String(tallaAnterior)) ? tallaAnterior : ''
          } else if (tipoNormalizado === 'ropa') {
            const permitidas = tallasRopa.map(t => String(t && t.value != null ? t.value : t))
            linea.talla = permitidas.includes(String(tallaAnterior)) ? tallaAnterior : ''
          } else {
            linea.talla = ''
          }
        } else {
          // Si cambia de artículo, reiniciamos talla para evitar inconsistencias.
          linea.talla = ''
        }

        // Vincular el artículo catalogado
        linea.idArticulo = idArticuloNuevo
        linea.esCatalogado = true
        linea.descripcionArticuloOriginal = articulo.DESCRIPCION || '' // Guardar descripción original

        // Actualizar la línea
        this.actualizarLinea(grupoId, index)
      }
    },
    seleccionarArticuloPuente (articulo, seccionId, grupoId, index) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (seccion) {
        const grupo = seccion.grupos.find(g => g.id === grupoId)
        if (grupo && grupo.lineasVisibles[index]) {
          const linea = grupo.lineasVisibles[index]
          if (!this.puedeRellenarLineaVacia(linea, grupo)) {
            this.$message.warning(`No se pueden añadir más de ${MAX_LINEAS_POR_SECCION} líneas en el grupo ${grupo.nombre}`)
            return
          }
          const idArticuloNuevo = articulo.IDARTICULOS || null
          const mismoArticulo =
						linea.idArticulo != null &&
						idArticuloNuevo != null &&
						Number(linea.idArticulo) === Number(idArticuloNuevo)
          const tallaAnterior = linea.talla

          const tipoTallaje = (articulo.TIPO_TALLAJE || articulo.tipoTallaje || articulo.tipo_tallaje || '').toString()
          const tallasCalzado = Array.isArray(articulo.__tallas_calzado) ? articulo.__tallas_calzado : []
          const tallasRopa = Array.isArray(articulo.__tallas_ropa) ? articulo.__tallas_ropa : []

          // Rellenar campos con los datos del artículo catalogado
          linea.referencia = this.limitarReferencia(articulo.CODIGO || '')
          linea.equipo = articulo.DESCRIPCION || ''
          linea.tipoTallaje = tipoTallaje
          linea.tallas_calzado = tallasCalzado
          linea.tallas_ropa = tallasRopa

          // Unidad de medida: el backend calcula conversiones si `linea.unidad` coincide exacto con
          // `articulo.articulo_conversion[].CONVERSION`.
          const conversiones = Array.isArray(articulo.articulo_conversion)
            ? articulo.articulo_conversion
            : (Array.isArray(articulo.articuloConversion) ? articulo.articuloConversion : [])

          linea.articulo_conversion = conversiones

          if (conversiones.length) {
            const unidadBase = this.getUnidadBaseArticulo(articulo)
            linea.unidadBase = unidadBase
            const opciones = this.getOpcionesUnidadDesdeArticulo(articulo, conversiones)
            const unidadPersistida = (articulo.UNIDAD || '').toString().trim()
            const unidadInicial = opciones.some(o => o.value === unidadPersistida) ? unidadPersistida : unidadBase
            linea.unidad = unidadInicial
            linea.unidadSelector = unidadInicial
          } else {
            linea.unidad = (articulo.UNIDAD || '').toString()
            linea.unidadBase = ''
            linea.unidadSelector = ''
          }

          // Conservar talla al re-seleccionar el mismo artículo si sigue siendo válida.
          if (mismoArticulo) {
            const tipoNormalizado = (tipoTallaje || '').toLowerCase()
            if (tipoNormalizado === 'calzado') {
              const permitidas = tallasCalzado.map(t => String(t && t.value != null ? t.value : t))
              linea.talla = permitidas.includes(String(tallaAnterior)) ? tallaAnterior : ''
            } else if (tipoNormalizado === 'ropa') {
              const permitidas = tallasRopa.map(t => String(t && t.value != null ? t.value : t))
              linea.talla = permitidas.includes(String(tallaAnterior)) ? tallaAnterior : ''
            } else {
              linea.talla = ''
            }
          } else {
            // Si cambia de artículo, reiniciamos talla para evitar inconsistencias.
            linea.talla = ''
          }

          // Vincular el artículo catalogado
          linea.idArticulo = idArticuloNuevo
          linea.esCatalogado = true
          linea.descripcionArticuloOriginal = articulo.DESCRIPCION || '' // Guardar descripción original

          // Actualizar la línea
          this.actualizarLineaPuente(seccionId, grupoId, index)
        }
      }
    },
    onReferenciaChange (grupoId, index) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (grupo && grupo.lineasVisibles[index]) {
        const linea = grupo.lineasVisibles[index]
        const snapshot = { referencia: linea.referencia, equipo: linea.equipo }
        linea.referencia = this.limitarReferencia(linea.referencia)

        // Si se escribe manualmente (no catalogado) y hay datos, asegurar código XXXXX
        if (!linea.esCatalogado && !linea.idArticulo) {
          // Si hay referencia pero no es XXXXX y no es catalogado, mantener lo que escribió
          // El código XXXXX se asignará automáticamente si hay equipo pero no referencia
        }

        if (!this.revertirSiExcedeLimiteLinea(linea, snapshot, grupo)) return
        this.actualizarLinea(grupoId, index)
      }
    },
    onEquipoChange (grupoId, index) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (grupo && grupo.lineasVisibles[index]) {
        const linea = grupo.lineasVisibles[index]
        const snapshot = { referencia: linea.referencia, equipo: linea.equipo }

        // Si hay un artículo catalogado y se modifica la descripción, deseleccionarlo
        if (linea.esCatalogado && linea.idArticulo && linea.descripcionArticuloOriginal) {
          if (linea.equipo !== linea.descripcionArticuloOriginal) {
            // El usuario ha modificado la descripción, deseleccionar el artículo
            linea.idArticulo = null
            linea.esCatalogado = false
            linea.descripcionArticuloOriginal = ''
            linea.tipoTallaje = ''
            linea.tallas_calzado = []
            linea.tallas_ropa = []
            linea.unidadBase = ''
            linea.articulo_conversion = []
            linea.unidadSelector = ''
            linea.talla = ''
            // Si la referencia era el código del artículo, cambiarla a XXXXX
            if (linea.referencia && linea.referencia !== 'XXXXX') {
              linea.referencia = 'XXXXX'
            }
          }
        }

        // Si se escribe manualmente en equipo y no es catalogado, asignar código genérico XXXXX
        if (!linea.esCatalogado && !linea.idArticulo && linea.equipo && linea.equipo.trim() !== '') {
          // Si no hay referencia o está vacía, asignar XXXXX para artículos no catalogados
          if (!linea.referencia || linea.referencia.trim() === '') {
            linea.referencia = 'XXXXX'
          }
        }

        if (!this.revertirSiExcedeLimiteLinea(linea, snapshot, grupo)) return
        this.actualizarLinea(grupoId, index)
      }
    },
    onReferenciaChangePuente (seccionId, grupoId, index) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (seccion) {
        const grupo = seccion.grupos.find(g => g.id === grupoId)
        if (grupo && grupo.lineasVisibles[index]) {
          const linea = grupo.lineasVisibles[index]
          const snapshot = { referencia: linea.referencia, equipo: linea.equipo }
          linea.referencia = this.limitarReferencia(linea.referencia)

          // Si se escribe manualmente (no catalogado) y hay datos, asegurar código XXXXX
          if (!linea.esCatalogado && !linea.idArticulo) {
            // Si hay referencia pero no es XXXXX y no es catalogado, mantener lo que escribió
            // El código XXXXX se asignará automáticamente si hay equipo pero no referencia
          }

          if (!this.revertirSiExcedeLimiteLinea(linea, snapshot, grupo)) return
          this.actualizarLineaPuente(seccionId, grupoId, index)
        }
      }
    },
    onEquipoChangePuente (seccionId, grupoId, index) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (seccion) {
        const grupo = seccion.grupos.find(g => g.id === grupoId)
        if (grupo && grupo.lineasVisibles[index]) {
          const linea = grupo.lineasVisibles[index]
          const snapshot = { referencia: linea.referencia, equipo: linea.equipo }

          // Si hay un artículo catalogado y se modifica la descripción, deseleccionarlo
          if (linea.esCatalogado && linea.idArticulo && linea.descripcionArticuloOriginal) {
            if (linea.equipo !== linea.descripcionArticuloOriginal) {
              // El usuario ha modificado la descripción, deseleccionar el artículo
              linea.idArticulo = null
              linea.esCatalogado = false
              linea.descripcionArticuloOriginal = ''
              linea.tipoTallaje = ''
              linea.tallas_calzado = []
              linea.tallas_ropa = []
              linea.unidadBase = ''
              linea.articulo_conversion = []
              linea.unidadSelector = ''
              linea.talla = ''
              // Si la referencia era el código del artículo, cambiarla a XXXXX
              if (linea.referencia && linea.referencia !== 'XXXXX') {
                linea.referencia = 'XXXXX'
              }
            }
          }

          // Si se escribe manualmente en equipo y no es catalogado, asignar código genérico XXXXX
          if (!linea.esCatalogado && !linea.idArticulo && linea.equipo && linea.equipo.trim() !== '') {
            // Si no hay referencia o está vacía, asignar XXXXX para artículos no catalogados
            if (!linea.referencia || linea.referencia.trim() === '') {
              linea.referencia = 'XXXXX'
            }
          }

          if (!this.revertirSiExcedeLimiteLinea(linea, snapshot, grupo)) return
          this.actualizarLineaPuente(seccionId, grupoId, index)
        }
      }
    },
    actualizarLinea (grupoId, index) {
      // Método para actualizar una línea específica
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (grupo && grupo.lineasVisibles[index]) {
        // Sincronizar con el array completo de líneas
        const lineaVisible = grupo.lineasVisibles[index]
        const indiceEnLineas = grupo.lineas.findIndex(l => l.posicion === lineaVisible.posicion)
        if (indiceEnLineas !== -1) {
          grupo.lineas[indiceEnLineas] = { ...lineaVisible }
        }
      }
    },
    actualizarLineaPuente (seccionId, grupoId, index) {
      // Método para actualizar una línea específica en PUENTE
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (seccion) {
        const grupo = seccion.grupos.find(g => g.id === grupoId)
        if (grupo && grupo.lineasVisibles[index]) {
          const lineaVisible = grupo.lineasVisibles[index]
          const indiceEnLineas = grupo.lineas.findIndex(l => l.posicion === lineaVisible.posicion)
          if (indiceEnLineas !== -1) {
            grupo.lineas[indiceEnLineas] = { ...lineaVisible }
          }
        }
      }
    },
    getUnidadBaseArticulo (articulo) {
      const base = ((articulo && articulo.UNIDAD) || '').toString().trim()
      return base || 'Uds'
    },
    getOpcionesUnidadDesdeArticulo (articulo, conversiones) {
      const base = this.getUnidadBaseArticulo(articulo)
      const opciones = [{ value: base, label: base }]
      const existentes = new Set([base.toLowerCase()])

			;(Array.isArray(conversiones) ? conversiones : []).forEach(c => {
        const conv = ((c && c.CONVERSION) || '').toString().trim()
        if (!conv) return
        const k = conv.toLowerCase()
        if (existentes.has(k)) return
        existentes.add(k)
        opciones.push({ value: conv, label: conv })
      })

      return opciones
    },
    tieneConversionesUnidad (linea) {
      return Array.isArray(linea && linea.articulo_conversion) && linea.articulo_conversion.length > 0
    },
    getOpcionesUnidad (linea) {
      if (!this.tieneConversionesUnidad(linea)) return []
      const base = ((linea && linea.unidadBase) || (linea && linea.unidad) || '').toString().trim() || 'Uds'
      return this.getOpcionesUnidadDesdeArticulo({ UNIDAD: base }, linea.articulo_conversion)
    },
    getConversionSeleccionada (linea) {
      if (!this.tieneConversionesUnidad(linea)) return null
      const unidadSel = ((linea && linea.unidad) || (linea && linea.unidadSelector) || '').toString().trim()
      if (!unidadSel) return null

      const base = ((linea && linea.unidadBase) || '').toString().trim() || 'Uds'
      if (unidadSel.toLowerCase() === base.toLowerCase()) return null

      const conversion = (linea.articulo_conversion || []).find(c =>
        ((c && c.CONVERSION) || '').toString().trim().toLowerCase() === unidadSel.toLowerCase()
      )
      return conversion || null
    },
    getTextoConversionInformativa (linea) {
      const conversion = this.getConversionSeleccionada(linea)
      if (!conversion) return ''

      const cantidadRaw = ((linea && linea.cantidad) != null ? linea.cantidad : '').toString().replace(',', '.')
      const factorRaw = ((conversion && conversion.CANTIDAD) != null ? conversion.CANTIDAD : '').toString().replace(',', '.')
      const cantidad = Number(cantidadRaw)
      const factor = Number(factorRaw)
      if (isNaN(cantidad) || isNaN(factor)) return ''

      const total = cantidad * factor
      const totalFmt = Number.isInteger(total) ? String(total) : total.toFixed(2).replace(/\.00$/, '')
      const base = ((linea && linea.unidadBase) || 'Uds').toString().trim() || 'Uds'
      return `= ${totalFmt} ${base}`
    },
    onUnidadSelectorChange (grupoId, index, val) {
      const grupo = this.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return

      const linea = grupo.lineasVisibles[index]
      const nuevoValor = String(val || '')
      linea.unidadSelector = nuevoValor
      linea.unidad = nuevoValor
      this.actualizarLinea(grupoId, index)
    },
    onUnidadSelectorChangePuente (seccionId, grupoId, index, val) {
      const seccion = this.secciones.find(s => s.id === seccionId)
      if (!seccion) return
      const grupo = seccion.grupos.find(g => g.id === grupoId)
      if (!grupo || !grupo.lineasVisibles[index]) return

      const linea = grupo.lineasVisibles[index]
      const nuevoValor = String(val || '')
      linea.unidadSelector = nuevoValor
      linea.unidad = nuevoValor
      this.actualizarLineaPuente(seccionId, grupoId, index)
    },
    async guardarPropuesta () {
      try {
        // Validar campos obligatorios
        if (!this.propuesta.buqueId || !this.propuesta.jMaquinas || !this.propuesta.fecha) {
          this.$message.warning('Por favor, complete todos los campos de la cabecera')
          return
        }

        // Validar tallaje forzado (Calzado/Ropa)
        if (!this.validarTallajeForzado()) return
        if (!this.validarCantidadesPedido()) return
        if (!this.validarMaximoLineasPorSeccion()) return

        // Recopilar todas las líneas que tengan datos (referencia o equipo)
        const lineas = []

        if (this.propuesta.tipo === 'PUENTE') {
          // Para PUENTE, recorrer secciones y grupos
          this.secciones.forEach(seccion => {
            seccion.grupos.forEach(grupo => {
              grupo.lineasVisibles.forEach(linea => {
                if (linea.referencia || linea.equipo) {
                  lineas.push({
                    grupo: grupo.codigo,
                    grupoNombre: grupo.nombre,
                    seccion: seccion.nombre,
                    posicion: linea.posicion,
                    referencia: linea.referencia || '',
                    equipo: linea.equipo || '',
                    cantidad: linea.cantidad || 0,
                    unidad: linea.unidad || '',
                    talla: linea.talla || '',
                    notas: linea.notas || '',
                    estado: linea.estado || 'PENDIENTE',
                    idArticulo: linea.idArticulo || null,
                    esCatalogado: linea.esCatalogado || false
                  })
                }
              })
            })
          })
        } else {
          // Para MAQUINAS, recorrer grupos directamente
          this.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(linea => {
              if (linea.referencia || linea.equipo) {
                lineas.push({
                  grupo: grupo.codigo,
                  grupoNombre: grupo.nombre,
                  posicion: linea.posicion,
                  referencia: linea.referencia || '',
                  equipo: linea.equipo || '',
                  cantidad: linea.cantidad || 0,
                  unidad: linea.unidad || '',
                  talla: linea.talla || '',
                  notas: linea.notas || '',
                  estado: linea.estado || 'PENDIENTE',
                  idArticulo: linea.idArticulo || null,
                  esCatalogado: linea.esCatalogado || false
                })
              }
            })
          })
        }

        if (lineas.length === 0) {
          this.$message.warning('Debe añadir al menos una línea con datos')
          return
        }

        // Preparar datos para enviar
        // Convertir fecha de YYYY-MM-DD a DD/MM/YYYY para el backend
        const fechaFormateada = this.propuesta.fecha
          ? moment(this.propuesta.fecha, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : moment().format('DD/MM/YYYY')

        const datos = {
          cabecera: {
            buqueId: this.propuesta.buqueId,
            buque: this.propuesta.buqueNombre,
            jefeMaquinas: this.propuesta.jMaquinas,
            fecha: fechaFormateada,
            tipo: this.propuesta.tipo,
            numeroPropuesta: this.propuesta.numeroPropuesta || null
          },
          lineas: lineas
        }

        // Obtener endpoints
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración. Por favor, recargue la página.')
          return
        }

        // Realizar la llamada al backend
        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/guardarPropuestaPedido`,
          datos
        )

        // Si el backend devuelve el número de propuesta, actualizarlo
        if (response.data && response.data.numeroPropuesta) {
          this.propuesta.numeroPropuesta = response.data.numeroPropuesta
        }

        // Si el backend devuelve el ID de la propuesta, actualizarlo
        if (response.data && response.data.id) {
          this.propuesta.id = response.data.id
        }
        // Sincronizar IDs de líneas recién creadas para permitir subir documentos sin recargar.
        const lineasGuardadas = response.data && Array.isArray(response.data.lineas) ? response.data.lineas : []
        if (lineasGuardadas.length) {
          await this.cargarLineasDesdeBackend(lineasGuardadas)
        }

        this.$message.success('Propuesta guardada correctamente')

        // Preguntar si quiere seguir editando o cerrar la ventana
        try {
          await this.$confirm('¿Qué desea hacer ahora?', 'Propuesta guardada', {
            confirmButtonText: 'Seguir editando',
            cancelButtonText: 'Cerrar ventana',
            type: 'success',
            distinguishCancelAndClose: true,
            closeOnClickModal: false
          })
          // Si elige "Seguir editando", recargar la propuesta completa
          // para mantener IDs de líneas y estado sincronizados con backend.
          if (this.propuesta.id) {
            await this.cargarPropuestaSeleccionada(this.propuesta.id)
          }
        } catch (action) {
          // Si elige "Cerrar ventana" o cierra el diálogo
          if (action === 'cancel') {
            // Solo cerrar la ventana sin lanzar la propuesta
            this.cerrarVentana()
          }
        }
      } catch (error) {
        console.error('Error al guardar propuesta:', error)
        this.$message.error('Error al guardar la propuesta. Por favor, intente nuevamente.')
      }
    },
    iniciarAutoguardado () {
      // Limpiar intervalo anterior si existe
      if (this.intervaloAutoguardado) {
        clearInterval(this.intervaloAutoguardado)
      }
      // Configurar autoguardado cada 5 minutos (300000 ms)
      this.intervaloAutoguardado = setInterval(() => {
        this.autoguardarPropuesta()
      }, 300000) // 5 minutos = 300000 milisegundos
    },
    async autoguardarPropuesta () {
      // Solo autoguardar si hay una propuesta abierta (modal cerrado)
      if (this.modalInicial.visible) {
        return
      }

      try {
        // Validar campos obligatorios
        if (!this.propuesta.buqueId || !this.propuesta.jMaquinas || !this.propuesta.fecha) {
          // No mostrar mensaje en autoguardado si faltan campos obligatorios
          return
        }

        // No autoguardar si hay tallaje forzado sin talla seleccionada
        if (this.hayTallajeForzadoIncompleto()) {
          return
        }
        if (this.hayCantidadesPedidoInvalidas()) {
          return
        }
        if (!this.validarMaximoLineasPorSeccion(true)) {
          return
        }

        // Recopilar todas las líneas que tengan datos (referencia o equipo)
        const lineas = []

        if (this.propuesta.tipo === 'PUENTE') {
          // Para PUENTE, recorrer secciones y grupos
          this.secciones.forEach(seccion => {
            seccion.grupos.forEach(grupo => {
              grupo.lineasVisibles.forEach(linea => {
                if (linea.referencia || linea.equipo) {
                  lineas.push({
                    grupo: grupo.codigo,
                    grupoNombre: grupo.nombre,
                    seccion: seccion.nombre,
                    posicion: linea.posicion,
                    referencia: linea.referencia || '',
                    equipo: linea.equipo || '',
                    cantidad: linea.cantidad || 0,
                    unidad: linea.unidad || '',
                    talla: linea.talla || '',
                    notas: linea.notas || '',
                    estado: linea.estado || 'PENDIENTE',
                    idArticulo: linea.idArticulo || null,
                    esCatalogado: linea.esCatalogado || false
                  })
                }
              })
            })
          })
        } else {
          // Para MAQUINAS, recorrer grupos directamente
          this.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(linea => {
              if (linea.referencia || linea.equipo) {
                lineas.push({
                  grupo: grupo.codigo,
                  grupoNombre: grupo.nombre,
                  posicion: linea.posicion,
                  referencia: linea.referencia || '',
                  equipo: linea.equipo || '',
                  cantidad: linea.cantidad || 0,
                  unidad: linea.unidad || '',
                  talla: linea.talla || '',
                  notas: linea.notas || '',
                  estado: linea.estado || 'PENDIENTE',
                  idArticulo: linea.idArticulo || null,
                  esCatalogado: linea.esCatalogado || false
                })
              }
            })
          })
        }

        // Si no hay líneas con datos, no guardar
        if (lineas.length === 0) {
          return
        }

        // Preparar datos para enviar
        // Convertir fecha de YYYY-MM-DD a DD/MM/YYYY para el backend
        const fechaFormateada = this.propuesta.fecha
          ? moment(this.propuesta.fecha, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : moment().format('DD/MM/YYYY')

        const datos = {
          cabecera: {
            buqueId: this.propuesta.buqueId,
            buque: this.propuesta.buqueNombre,
            jefeMaquinas: this.propuesta.jMaquinas,
            fecha: fechaFormateada,
            tipo: this.propuesta.tipo,
            numeroPropuesta: this.propuesta.numeroPropuesta || null
          },
          lineas: lineas
        }

        // Obtener endpoints
        const endpoints = getUrl()
        if (!endpoints) {
          // No mostrar mensaje en autoguardado si hay error de configuración
          return
        }

        // Realizar la llamada al backend
        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/guardarPropuestaPedido`,
          datos
        )

        // Si el backend devuelve el número de propuesta, actualizarlo
        if (response.data && response.data.numeroPropuesta) {
          this.propuesta.numeroPropuesta = response.data.numeroPropuesta
        }
        // Sincronizar líneas tras autoguardado (IDs de líneas incluidas).
        const lineasGuardadas = response.data && Array.isArray(response.data.lineas) ? response.data.lineas : []
        if (lineasGuardadas.length) {
          await this.cargarLineasDesdeBackend(lineasGuardadas)
        }

        // No mostrar mensaje de éxito en autoguardado para no ser intrusivo
        console.log('Autoguardado realizado correctamente')
      } catch (error) {
        // Solo mostrar error en consola, no mostrar mensaje al usuario en autoguardado
        // para no ser intrusivo, pero sí registrar el error
        console.error('Error en autoguardado:', error)
      }
    },
    mostrarAvisoPropuestaAbierta (esContinuar) {
      const codigo = (this.propuesta.numeroPropuesta || '').trim()
      if (esContinuar && codigo) {
        this.$message.info(`A continuación seguirá editando la propuesta ${codigo}`)
      } else {
        const texto = codigo ? `Se ha generado la propuesta ${codigo}` : 'Se ha generado una nueva propuesta'
        this.$message.info(texto)
      }
    },
    seleccionarNuevaPropuesta () {
      this.modalInicial.paso = 2
    },
    seleccionarContinuarPropuesta () {
      this.modalInicial.paso = 3
      this.cargarPropuestasPendientes()
    },
    async seleccionarTipoPropuesta (tipo) {
      this.propuesta.tipo = tipo
      this.modalInicial.visible = false
      await this.inicializarGrupos()
      await this.cargarDestinos()
      this.mostrarAvisoPropuestaAbierta(false)
    },
    async cargarPropuestasPendientes () {
      try {
        this.loadingPropuestas = true
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/listarPropuestasPendientes`,
          { tipo: null } // null para obtener todas
        )

        if (Array.isArray(response.data)) {
          this.listaPropuestasPendientes = response.data
        } else if (response.data && Array.isArray(response.data.data)) {
          this.listaPropuestasPendientes = response.data.data
        } else {
          this.listaPropuestasPendientes = []
        }

        if (this.listaPropuestasPendientes.length === 0) {
          this.$message.info('No hay propuestas pendientes')
        }
      } catch (error) {
        console.error('Error al cargar propuestas pendientes:', error)
        this.$message.error('Error al cargar las propuestas pendientes')
        this.listaPropuestasPendientes = []
      } finally {
        this.loadingPropuestas = false
      }
    },
    async cargarPropuestaSeleccionada (propuestaId) {
      try {
        this.loadingPropuestas = true
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/obtenerPropuesta`,
          { id: propuestaId }
        )

        if (response.data && response.data.cabecera) {
          // Guardar el ID de la propuesta para poder cerrarla después
          this.propuesta.id = response.data.id

          // Cargar datos de la cabecera
          this.propuesta.buqueId = response.data.cabecera.buqueId
          this.propuesta.buqueNombre = response.data.cabecera.buque
          this.propuesta.jMaquinas = response.data.cabecera.jefeMaquinas
          this.propuesta.fecha = moment(response.data.cabecera.fecha, 'DD/MM/YYYY').format('YYYY-MM-DD')
          this.propuesta.numeroPropuesta = response.data.cabecera.numeroPropuesta || response.data.codigo
          // Si el tipo está vacío, asumir MAQUINAS por defecto
          this.propuesta.tipo = response.data.cabecera.tipo || 'MAQUINAS'

          // Cargar grupos según el tipo
          await this.inicializarGrupos()
          await this.cargarDestinos()

          // Cargar líneas
          const lineas = response.data.lineas && Array.isArray(response.data.lineas) ? response.data.lineas : []
          if (lineas.length > 0) {
            await this.cargarLineasDesdeBackend(lineas)
          }

          this.modalInicial.visible = false
          // Si no tiene líneas, mostrar mensaje de "generada"; si tiene, "seguirá editando"
          this.mostrarAvisoPropuestaAbierta(lineas.length > 0)
        } else {
          this.$message.error('Error al cargar la propuesta')
        }
      } catch (error) {
        console.error('Error al cargar propuesta:', error)
        this.$message.error('Error al cargar la propuesta seleccionada')
      } finally {
        this.loadingPropuestas = false
      }
    },
    async cargarLineasDesdeBackend (lineasBackend) {
      console.log('Cargando líneas desde backend:', lineasBackend)
      console.log('Tipo de propuesta:', this.propuesta.tipo)
      console.log('Grupos disponibles:', this.grupos.length)

      // Conjuntos para rastrear qué grupos y secciones tienen datos
      const gruposConDatos = new Set()
      const seccionesConDatos = new Set()

      // Mapear las líneas del backend a la estructura de grupos
      lineasBackend.forEach(lineaBackend => {
        // Normalizar el estado a mayúsculas
        const estadoNormalizado = lineaBackend.estado ? lineaBackend.estado.toUpperCase() : 'PENDIENTE'

        console.log(`Procesando línea: grupo=${lineaBackend.grupo}, posicion=${lineaBackend.posicion}`)

        if (this.propuesta.tipo === 'PUENTE') {
          // Para PUENTE, buscar en secciones
          this.secciones.forEach(seccion => {
            seccion.grupos.forEach(grupo => {
              if (grupo.codigo === lineaBackend.grupo) {
                // Encontrar la línea por posición
                const linea = grupo.lineas.find(l => l.posicion === lineaBackend.posicion)
                if (linea) {
                  const idArticuloBackend = lineaBackend.idArticulo || lineaBackend.IDARTICULOS || lineaBackend.id_articulo || null
                  const tipoTallajeBackend = lineaBackend.tipoTallaje || lineaBackend.TIPO_TALLAJE || lineaBackend.tipo_tallaje || ''
                  const conversionesBackend = Array.isArray(lineaBackend.articulo_conversion)
                    ? lineaBackend.articulo_conversion
                    : (Array.isArray(lineaBackend.ARTICULO_CONVERSION) ? lineaBackend.ARTICULO_CONVERSION : [])
                  const esCatalogadoBackend = (lineaBackend.esCatalogado !== undefined && lineaBackend.esCatalogado !== null)
                    ? !!lineaBackend.esCatalogado
                    : (!!idArticuloBackend || !!tipoTallajeBackend || conversionesBackend.length > 0)
                  Object.assign(linea, {
                    referencia: this.limitarReferencia(lineaBackend.referencia || ''),
                    equipo: lineaBackend.equipo || '',
                    cantidad: lineaBackend.cantidad || '',
                    unidad: lineaBackend.unidad || '',
                    talla: lineaBackend.talla || lineaBackend.TALLA || '',
                    tipoTallaje: tipoTallajeBackend,
                    notas: lineaBackend.notas || '',
                    estado: estadoNormalizado,
                    idArticulo: idArticuloBackend,
                    esCatalogado: esCatalogadoBackend,
                    descripcionArticuloOriginal: esCatalogadoBackend ? (lineaBackend.equipo || '') : '',
                    idLineaPropuesta: lineaBackend.idLineaPropuesta || lineaBackend.id || null,
                    tieneDocumento: !!(lineaBackend.tieneDocumento || lineaBackend.documentoAsociado || lineaBackend.tiene_documento)
                  })
                  linea.articulo_conversion = conversionesBackend
                  linea.tallas_calzado = Array.isArray(lineaBackend.tallas_calzado) ? lineaBackend.tallas_calzado : (Array.isArray(lineaBackend.TALLAS_CALZADO) ? lineaBackend.TALLAS_CALZADO : [])
                  linea.tallas_ropa = Array.isArray(lineaBackend.tallas_ropa) ? lineaBackend.tallas_ropa : (Array.isArray(lineaBackend.TALLAS_ROPA) ? lineaBackend.TALLAS_ROPA : [])
                  if (conversionesBackend.length) {
                    linea.unidadBase = this.getUnidadBaseArticulo({
                      UNIDAD: lineaBackend.unidadBase || lineaBackend.UNIDAD_BASE || lineaBackend.UNIDAD || ''
                    })
                    const opcionesUnidad = this.getOpcionesUnidad(linea)
                    const unidadActual = (linea.unidad || '').toString().trim()
                    const unidadValida = opcionesUnidad.some(o => o.value === unidadActual)
                    const unidadFinal = unidadValida ? unidadActual : linea.unidadBase
                    linea.unidad = unidadFinal
                    linea.unidadSelector = unidadFinal
                  } else {
                    linea.unidadBase = ''
                    linea.unidadSelector = ''
                  }
                  // Añadir a líneas visibles si tiene datos
                  if (linea.referencia || linea.equipo) {
                    if (this.contarLineasGrupo(grupo) > MAX_LINEAS_POR_SECCION) {
                      this.limpiarLinea(linea)
                      return
                    }
                    const existeEnVisibles = grupo.lineasVisibles.find(l => l.posicion === linea.posicion)
                    if (!existeEnVisibles && grupo.lineasVisibles.length < MAX_LINEAS_POR_SECCION) {
                      grupo.lineasVisibles.push(linea)
                    } else {
                      // Actualizar la línea visible existente
                      Object.assign(existeEnVisibles, linea)
                    }
                    // Marcar grupo y sección como con datos
                    gruposConDatos.add(`${seccion.id}-${grupo.id}`)
                    seccionesConDatos.add(seccion.id)
                  }
                }
              }
            })
          })
        } else {
          // Para MAQUINAS (o tipo vacío), buscar en grupos
          const grupo = this.grupos.find(g => g.codigo === lineaBackend.grupo)
          console.log(`Buscando grupo ${lineaBackend.grupo}:`, grupo ? 'encontrado' : 'no encontrado')

          if (grupo) {
            // Buscar la línea por posición (puede ser número o string)
            const posicionBuscada = typeof lineaBackend.posicion === 'string'
              ? parseInt(lineaBackend.posicion)
              : lineaBackend.posicion

            console.log(`Buscando línea con posición ${posicionBuscada} en grupo ${grupo.codigo}`)
            console.log(`Posiciones disponibles en grupo:`, grupo.lineas.map(l => l.posicion).slice(0, 5))

            let linea = grupo.lineas.find(l => l.posicion === posicionBuscada)

            // Si no se encuentra por posición exacta, buscar la primera disponible o crear una nueva
            if (!linea) {
              console.log(`No se encontró línea con posición exacta ${posicionBuscada}, buscando línea vacía`)
              // Buscar una línea vacía en el grupo
              linea = grupo.lineas.find(l => !l.referencia && !l.equipo)
              if (linea) {
                console.log(`Usando línea vacía con posición ${linea.posicion}, actualizando a ${posicionBuscada}`)
                // Actualizar la posición de la línea vacía
                linea.posicion = posicionBuscada
              } else {
                // Si no hay líneas vacías, usar la primera línea disponible
                linea = grupo.lineas[0]
                if (linea) {
                  console.log(`Usando primera línea disponible con posición ${linea.posicion}, actualizando a ${posicionBuscada}`)
                  linea.posicion = posicionBuscada
                }
              }
            } else {
              console.log(`Línea encontrada con posición ${posicionBuscada}`)
            }

            if (linea) {
              const idArticuloBackend = lineaBackend.idArticulo || lineaBackend.IDARTICULOS || lineaBackend.id_articulo || null
              const tipoTallajeBackend = lineaBackend.tipoTallaje || lineaBackend.TIPO_TALLAJE || lineaBackend.tipo_tallaje || ''
              const conversionesBackend = Array.isArray(lineaBackend.articulo_conversion)
                ? lineaBackend.articulo_conversion
                : (Array.isArray(lineaBackend.ARTICULO_CONVERSION) ? lineaBackend.ARTICULO_CONVERSION : [])
              const esCatalogadoBackend = (lineaBackend.esCatalogado !== undefined && lineaBackend.esCatalogado !== null)
                ? !!lineaBackend.esCatalogado
                : (!!idArticuloBackend || !!tipoTallajeBackend || conversionesBackend.length > 0)
              Object.assign(linea, {
                referencia: this.limitarReferencia(lineaBackend.referencia || ''),
                equipo: lineaBackend.equipo || '',
                cantidad: lineaBackend.cantidad || '',
                unidad: lineaBackend.unidad || '',
                talla: lineaBackend.talla || lineaBackend.TALLA || '',
                tipoTallaje: tipoTallajeBackend,
                notas: lineaBackend.notas || '',
                estado: estadoNormalizado,
                posicion: posicionBuscada, // Asegurar que la posición sea correcta
                idArticulo: idArticuloBackend,
                esCatalogado: esCatalogadoBackend,
                descripcionArticuloOriginal: esCatalogadoBackend ? (lineaBackend.equipo || '') : '',
                idLineaPropuesta: lineaBackend.idLineaPropuesta || lineaBackend.id || null,
                tieneDocumento: !!(lineaBackend.tieneDocumento || lineaBackend.documentoAsociado || lineaBackend.tiene_documento)
              })
              linea.articulo_conversion = conversionesBackend
              linea.tallas_calzado = Array.isArray(lineaBackend.tallas_calzado) ? lineaBackend.tallas_calzado : (Array.isArray(lineaBackend.TALLAS_CALZADO) ? lineaBackend.TALLAS_CALZADO : [])
              linea.tallas_ropa = Array.isArray(lineaBackend.tallas_ropa) ? lineaBackend.tallas_ropa : (Array.isArray(lineaBackend.TALLAS_ROPA) ? lineaBackend.TALLAS_ROPA : [])
              if (conversionesBackend.length) {
                linea.unidadBase = this.getUnidadBaseArticulo({
                  UNIDAD: lineaBackend.unidadBase || lineaBackend.UNIDAD_BASE || lineaBackend.UNIDAD || ''
                })
                const opcionesUnidad = this.getOpcionesUnidad(linea)
                const unidadActual = (linea.unidad || '').toString().trim()
                const unidadValida = opcionesUnidad.some(o => o.value === unidadActual)
                const unidadFinal = unidadValida ? unidadActual : linea.unidadBase
                linea.unidad = unidadFinal
                linea.unidadSelector = unidadFinal
              } else {
                linea.unidadBase = ''
                linea.unidadSelector = ''
              }
              console.log(`Línea actualizada:`, linea)

              // Añadir a líneas visibles si tiene datos
              if (linea.referencia || linea.equipo) {
                if (this.contarLineasGrupo(grupo) > MAX_LINEAS_POR_SECCION) {
                  this.limpiarLinea(linea)
                  return
                }
                const existeEnVisibles = grupo.lineasVisibles.find(l => l.posicion === posicionBuscada)
                if (!existeEnVisibles && grupo.lineasVisibles.length < MAX_LINEAS_POR_SECCION) {
                  console.log(`Añadiendo línea a visibles. Total antes: ${grupo.lineasVisibles.length}`)
                  grupo.lineasVisibles.push(linea)
                  console.log(`Total después: ${grupo.lineasVisibles.length}`)
                } else {
                  console.log(`Actualizando línea visible existente`)
                  // Actualizar la línea visible existente
                  Object.assign(existeEnVisibles, linea)
                }
                // Marcar grupo como con datos
                gruposConDatos.add(grupo.id)
              } else {
                console.log(`Línea no tiene datos, no se añade a visibles`)
              }
            } else {
              console.warn(`No se pudo asignar línea con posición ${posicionBuscada} en grupo ${lineaBackend.grupo}`)
            }
          } else {
            console.warn(`No se encontró grupo con código ${lineaBackend.grupo}`)
            console.log(`Grupos disponibles:`, this.grupos.map(g => g.codigo))
          }
        }
      })

      // Expandir grupos y secciones que tienen datos
      if (this.propuesta.tipo === 'PUENTE') {
        // Para PUENTE, expandir secciones y grupos con datos
        this.secciones.forEach(seccion => {
          if (seccionesConDatos.has(seccion.id)) {
            seccion.visible = true
          }
          seccion.grupos.forEach(grupo => {
            if (gruposConDatos.has(`${seccion.id}-${grupo.id}`)) {
              grupo.visible = true
            }
          })
        })
      } else {
        // Para MAQUINAS, expandir solo grupos con datos
        this.grupos.forEach(grupo => {
          if (gruposConDatos.has(grupo.id)) {
            grupo.visible = true
          }
        })
      }
      this.normalizarLimitesLineas()
      await this.hidratarLineasCatalogadasDesdeCatalogo()
    },
    async hidratarLineasCatalogadasDesdeCatalogo () {
      const endpoints = getUrl()
      if (!endpoints) return

      const peticiones = []
      const encolar = (grupo) => {
        if (!grupo || !grupo.tieneArticulos) return
        const lineasCatalogadas = (grupo.lineas || []).filter(l => l && (
          l.idArticulo ||
					l.esCatalogado ||
					(Array.isArray(l.articulo_conversion) && l.articulo_conversion.length > 0) ||
					((l.tipoTallaje || '').toString().trim() !== '')
        ))
        if (!lineasCatalogadas.length) return
        peticiones.push(
          axios.post(
            `${endpoints.backend}entidad/articulos/buscador/listarArticulosSeccion`,
            { id: grupo.id }
          ).then(resp => ({ resp, grupo }))
        )
      }

      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          (seccion.grupos || []).forEach(grupo => encolar(grupo))
        })
      } else {
        (this.grupos || []).forEach(grupo => encolar(grupo))
      }

      if (!peticiones.length) return

      const resultados = await Promise.allSettled(peticiones)
      resultados.forEach(r => {
        if (r.status !== 'fulfilled') return
        const { resp, grupo } = r.value
        let articulos = []
        let tallasCalzado = []
        let tallasRopa = []

        if (Array.isArray(resp.data)) {
          articulos = resp.data
        } else if (resp.data && Array.isArray(resp.data.data)) {
          articulos = resp.data.data
        } else if (resp.data && Array.isArray(resp.data.articulos)) {
          articulos = resp.data.articulos
          tallasCalzado = Array.isArray(resp.data.tallas_calzado) ? resp.data.tallas_calzado : []
          tallasRopa = Array.isArray(resp.data.tallas_ropa) ? resp.data.tallas_ropa : []
        } else if (resp.data && resp.data.data && Array.isArray(resp.data.data.articulos)) {
          articulos = resp.data.data.articulos
          tallasCalzado = Array.isArray(resp.data.data.tallas_calzado) ? resp.data.data.tallas_calzado : []
          tallasRopa = Array.isArray(resp.data.data.tallas_ropa) ? resp.data.data.tallas_ropa : []
        }

        if (!articulos.length) return
        const porId = new Map()
        const porCodigo = new Map()
        const porDescripcion = new Map()
        articulos.forEach(a => {
          const id = a.IDARTICULOS || a.idArticulo || a.id_articulo
          if (id != null) porId.set(String(id), a)
          const cod = (a.CODIGO || '').toString().trim().toLowerCase()
          if (cod) porCodigo.set(cod, a)
          const desc = (a.DESCRIPCION || '').toString().trim().toLowerCase()
          if (desc) porDescripcion.set(desc, a)
        })

        ;(grupo.lineas || []).forEach(linea => {
          if (!linea || !(linea.idArticulo || linea.esCatalogado)) return
          const art = (linea.idArticulo != null && porId.get(String(linea.idArticulo)))
          || porCodigo.get((linea.referencia || '').toString().trim().toLowerCase())
          || porDescripcion.get((linea.equipo || '').toString().trim().toLowerCase())
          if (!art) {
            // Si no localizamos artículo exacto, al menos hidratar opciones de talla por tipo.
            const tipoLinea = (linea.tipoTallaje || '').toString().trim().toLowerCase()
            if (tipoLinea === 'calzado') linea.tallas_calzado = tallasCalzado
            if (tipoLinea === 'ropa') linea.tallas_ropa = tallasRopa
            return
          }

          const tipoTallaje = (art.TIPO_TALLAJE || art.tipoTallaje || art.tipo_tallaje || linea.tipoTallaje || '').toString()
          const conversiones = Array.isArray(art.articulo_conversion)
            ? art.articulo_conversion
            : (Array.isArray(art.articuloConversion) ? art.articuloConversion : [])

          linea.idArticulo = art.IDARTICULOS || linea.idArticulo || null
          linea.esCatalogado = true
          linea.tipoTallaje = tipoTallaje
          linea.tallas_calzado = tallasCalzado
          linea.tallas_ropa = tallasRopa
          linea.articulo_conversion = conversiones

          if (conversiones.length) {
            const unidadBase = this.getUnidadBaseArticulo(art)
            linea.unidadBase = unidadBase
            const opcionesUnidad = this.getOpcionesUnidad(linea)
            const unidadActual = (linea.unidad || '').toString().trim()
            const unidadValida = opcionesUnidad.some(o => o.value === unidadActual)
            const unidadFinal = unidadValida ? unidadActual : unidadBase
            linea.unidad = unidadFinal
            linea.unidadSelector = unidadFinal
          } else {
            linea.unidadSelector = ''
          }
        })
      })
    },
    async confirmarEliminarLinea (linea, grupo) {
      try {
        await this.$confirm(
          `¿Eliminar la línea en posición ${linea.posicion}? Las siguientes líneas del grupo se renumerarán.`,
          'Eliminar línea',
          {
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
            type: 'warning'
          }
        )
        this.eliminarLinea(linea, grupo)
      } catch {
        // Usuario canceló
      }
    },
    copiarDatosLinea (origen, destino) {
      destino.posicion = origen.posicion
      destino.referencia = this.limitarReferencia(origen.referencia || '')
      destino.equipo = origen.equipo || ''
      destino.cantidad = origen.cantidad || ''
      destino.unidad = origen.unidad || ''
      destino.unidadBase = origen.unidadBase || ''
      destino.articulo_conversion = Array.isArray(origen.articulo_conversion) ? origen.articulo_conversion : []
      destino.unidadSelector = origen.unidadSelector || ''
      destino.talla = origen.talla || ''
      destino.tipoTallaje = origen.tipoTallaje || ''
      destino.tallas_calzado = Array.isArray(origen.tallas_calzado) ? origen.tallas_calzado : []
      destino.tallas_ropa = Array.isArray(origen.tallas_ropa) ? origen.tallas_ropa : []
      destino.notas = origen.notas || ''
      destino.estado = origen.estado || 'PENDIENTE'
      destino.busquedaArticulo = origen.busquedaArticulo || ''
      destino.idArticulo = origen.idArticulo != null ? origen.idArticulo : null
      destino.esCatalogado = !!origen.esCatalogado
      destino.descripcionArticuloOriginal = origen.descripcionArticuloOriginal || ''
      destino.idLineaPropuesta = origen.idLineaPropuesta != null ? origen.idLineaPropuesta : null
      destino.tieneDocumento = !!origen.tieneDocumento
    },
    limpiarLinea (l) {
      l.referencia = ''
      l.equipo = ''
      l.cantidad = ''
      l.unidad = ''
      l.unidadBase = ''
      l.articulo_conversion = []
      l.unidadSelector = ''
      l.talla = ''
      l.tipoTallaje = ''
      l.tallas_calzado = []
      l.tallas_ropa = []
      l.notas = ''
      l.estado = 'PENDIENTE'
      l.busquedaArticulo = ''
      l.idArticulo = null
      l.esCatalogado = false
      l.descripcionArticuloOriginal = ''
      l.idLineaPropuesta = null
      l.tieneDocumento = false
    },
    eliminarLinea (linea, grupo) {
      const idx = grupo.lineasVisibles.findIndex(l => l === linea)
      if (idx === -1) return
      const base = Math.min(...grupo.lineasVisibles.map(l => l.posicion))
      grupo.lineasVisibles.splice(idx, 1)
      // Compactar: que las visibles sean las primeras N de grupo.lineas para que "añadir línea" use la siguiente vacía
      const visibleRefs = [...grupo.lineasVisibles]
      for (let i = 0; i < visibleRefs.length; i++) {
        this.copiarDatosLinea(visibleRefs[i], grupo.lineas[i])
        grupo.lineas[i].posicion = base + i
      }
      for (let i = visibleRefs.length; i < grupo.lineas.length; i++) {
        this.limpiarLinea(grupo.lineas[i])
        grupo.lineas[i].posicion = base + i
      }
      grupo.lineasVisibles = grupo.lineas.slice(0, visibleRefs.length)
      this.$message.success('Línea eliminada. Las posiciones del grupo se han actualizado.')
    },
    abrirSubirDocumentoLinea (linea, grupo) {
      if (!this.propuesta.id) {
        this.$message.warning('Guarde la propuesta antes de subir documentos a una línea.')
        return
      }
      if (!linea.idLineaPropuesta) {
        this.$message.warning('Debe guardar la propuesta y recargarla antes de subir documentos a esta línea.')
        return
      }
      this.modalSubirDocumentoLinea.propuestaId = linea.idLineaPropuesta
      this.modalSubirDocumentoLinea.grupoCodigo = grupo.codigo
      this.modalSubirDocumentoLinea.posicion = linea.posicion
      this.modalSubirDocumentoLinea.archivoSeleccionado = null
      this.modalSubirDocumentoLinea.tieneDocumentoPrevio = !!linea.tieneDocumento
      this.modalSubirDocumentoLinea.visible = true
      this.$nextTick(() => {
        if (this.$refs.inputFileDocumentoLinea) {
          this.$refs.inputFileDocumentoLinea.value = ''
        }
      })
    },
    marcarLineaConDocumento (grupoCodigo, posicion) {
      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          const grupo = seccion.grupos.find(g => g.codigo === grupoCodigo)
          if (grupo) {
            const linea = grupo.lineasVisibles.find(l => l.posicion === posicion)
            if (linea) linea.tieneDocumento = true
          }
        })
      } else {
        const grupo = this.grupos.find(g => g.codigo === grupoCodigo)
        if (grupo) {
          const linea = grupo.lineasVisibles.find(l => l.posicion === posicion)
          if (linea) linea.tieneDocumento = true
        }
      }
    },
    onFileSelectedLinea (event) {
      const file = event.target.files[0]
      if (file) {
        this.modalSubirDocumentoLinea.archivoSeleccionado = file
      }
    },
    async subirDocumentoLinea () {
      if (!this.modalSubirDocumentoLinea.archivoSeleccionado || !this.modalSubirDocumentoLinea.propuestaId) {
        this.$message.warning('Por favor, seleccione un archivo')
        return
      }

      this.modalSubirDocumentoLinea.subiendo = true

      try {
        const file = this.modalSubirDocumentoLinea.archivoSeleccionado
        const base64 = await this.fileToBase64(file)
        const mimeType = file.type || 'application/octet-stream'
        const payload = {
          grupo: this.modalSubirDocumentoLinea.grupoCodigo,
          posicion: this.modalSubirDocumentoLinea.posicion,
          DOCUMENTO: {
            attr: { divider: true, col: 24 },
            format: 'file',
            obligatorio: 1,
            class: null,
            textpre: '',
            textpos: '',
            title: 'Documento',
            title2: null,
            subtitle: null,
            value: {
              file: {},
              base64: `data:${mimeType};base64,${base64}`,
              name: file.name
            }
          }
        }

        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración')
          return
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/lineas_propuesta_pedido/${this.modalSubirDocumentoLinea.propuestaId}/subirDocumento`,
          payload
        )

        if (response.data && !response.data.error) {
          this.$message.success('Documento subido correctamente')
          // Marcar la línea como con documento asociado
          this.marcarLineaConDocumento(this.modalSubirDocumentoLinea.grupoCodigo, this.modalSubirDocumentoLinea.posicion)
          this.modalSubirDocumentoLinea.visible = false
          this.modalSubirDocumentoLinea.archivoSeleccionado = null
          this.modalSubirDocumentoLinea.propuestaId = null
          this.modalSubirDocumentoLinea.grupoCodigo = null
          this.modalSubirDocumentoLinea.posicion = null
          this.modalSubirDocumentoLinea.tieneDocumentoPrevio = false
        } else {
          const mensaje = (response.data && response.data.mensaje) ? response.data.mensaje : 'Error al subir el documento'
          this.$message.error(mensaje)
        }
      } catch (error) {
        console.error('Error al subir documento:', error)
        this.$message.error('Error al subir el documento. Por favor, intente nuevamente.')
      } finally {
        this.modalSubirDocumentoLinea.subiendo = false
      }
    },
    fileToBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          const base64String = reader.result.split(',')[1]
          resolve(base64String)
        }
        reader.onerror = error => reject(error)
        reader.readAsDataURL(file)
      })
    },
    cerrarVentana () {
      // Cerrar solo la ventana sin lanzar la propuesta
      // Si estamos en un iframe, emitir el evento al window.parent
      if (window.parent && window.parent !== window) {
        // Estamos en un iframe, emitir al parent
        if (window.parent.Vue && window.parent.Vue.prototype) {
          window.parent.Vue.prototype.$root.$emit('cerrar-ventana-propuesta')
        } else {
          // Fallback: usar postMessage
          window.parent.postMessage({ type: 'cerrar-ventana-propuesta' }, '*')
        }
      } else {
        // No estamos en iframe, emitir normalmente
        this.$root.$emit('cerrar-ventana-propuesta')
      }
    },
    obtenerLineasResumen () {
      const resumen = []
      if (this.propuesta.tipo === 'PUENTE') {
        this.secciones.forEach(seccion => {
          seccion.grupos.forEach(grupo => {
            grupo.lineasVisibles.forEach(linea => {
              if (linea.referencia || linea.equipo) {
                resumen.push({
                  equipo: linea.equipo || '',
                  cantidad: linea.cantidad != null && linea.cantidad !== '' ? linea.cantidad : '0'
                })
              }
            })
          })
        })
      } else {
        this.grupos.forEach(grupo => {
          grupo.lineasVisibles.forEach(linea => {
            if (linea.referencia || linea.equipo) {
              resumen.push({
                equipo: linea.equipo || '',
                cantidad: linea.cantidad != null && linea.cantidad !== '' ? linea.cantidad : '0'
              })
            }
          })
        })
      }
      return resumen
    },
    cerrarPropuesta () {
      // Validar que el campo J.MAQUINAS/CAPITAN esté relleno
      if (!this.propuesta.jMaquinas || this.propuesta.jMaquinas.trim() === '') {
        const campoNombre = this.propuesta.tipo === 'PUENTE' ? 'CAPITAN' : 'J.MAQUINAS'
        this.$message.warning(`Debe rellenar el campo ${campoNombre} antes de lanzar la propuesta.`)
        return
      }

      // Validar que hay un número de propuesta
      if (!this.propuesta.numeroPropuesta) {
        this.$message.warning('Debe guardar antes la propuesta.')
        return
      }

      const lineasResumen = this.obtenerLineasResumen()
      if (lineasResumen.length === 0) {
        this.$message.warning('Debe añadir al menos una línea con datos antes de lanzar la propuesta.')
        return
      }

      // Validar tallaje forzado (Calzado/Ropa)
      if (!this.validarTallajeForzado()) return
      if (!this.validarCantidadesPedido()) return
      if (!this.validarMaximoLineasPorSeccion()) return

      this.modalConfirmarLanzar.lineasResumen = lineasResumen
      this.modalConfirmarLanzar.visible = true
    },
    async ejecutarLanzarPropuesta () {
      this.modalConfirmarLanzar.visible = false
      try {
        const endpoints = getUrl()
        if (!endpoints) {
          this.$message.error('Error de configuración. Por favor, recargue la página.')
          return
        }

        const response = await axios.post(
          `${endpoints.backend}entidad/propuestas_pedido/buscador/cerrarPropuestaPedido`,
          {
            id: this.propuesta.id || null,
            codigo: this.propuesta.numeroPropuesta,
            estado: 2
          }
        )

        if (response.data && !response.data.error) {
          this.$message.success('Propuesta cerrada correctamente')
          this.cerrarVentana()
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        } else {
          const mensajeError = (response.data && response.data.mensaje) ? response.data.mensaje : 'Error al cerrar la propuesta'
          this.$message.error(mensajeError)
        }
      } catch (error) {
        console.error('Error al cerrar propuesta:', error)
        this.$message.error('Error al cerrar la propuesta. Por favor, intente nuevamente.')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.propuesta-page {
	padding: 1rem;
	background-color: $--color-background;
	min-height: 100vh;
}

.propuesta-container {
	background: white;
	border-radius: 4px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	padding: 1.5rem;
}

.propuesta-header {
	margin-bottom: 1.5rem;
	border-bottom: 2px solid $--color-header;
	padding-bottom: 1rem;

	.header-row {
		display: grid;
		grid-template-columns: 1fr 1fr 2fr 1fr 1fr;
		gap: 1rem;
		align-items: center;
		margin-bottom: 1rem;

		.header-field {
			display: flex;
			flex-direction: column;
			gap: 0.25rem;

			label {
				font-weight: bold;
				font-size: 0.85rem;
				color: $--color-main-header;
			}

			&.header-title {
				grid-column: 3;
				text-align: center;
				background-color: #f5f5f5;
				padding: 0.5rem;
				border-radius: 4px;

				h2 {
					margin: 0;
					font-size: 1.2rem;
					color: $--color-main-header;
				}

				.version {
					font-size: 0.75rem;
					color: #666;
				}
			}
		}
	}
}

.propuesta-table-container {
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	overflow: hidden;
}

.table-header {
	display: grid;
	grid-template-columns: 80px 200px 1fr 100px 120px 1fr 110px;
	background-color: $--color-main-header;
	color: white;
	font-weight: bold;
	font-size: 0.85rem;
	padding: 0.5rem;
	border-bottom: 2px solid $--color-main-header;

	> div {
		padding: 0.25rem;
		display: flex;
		align-items: center;
	}
}

.seccion-section {
	margin-bottom: 1rem;

	.seccion-header {
		color: white;
		font-weight: bold;
		padding: 1rem;
		border-bottom: 2px solid rgba(0, 0, 0, 0.2);
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		transition: all 0.2s;
		font-size: 1.1rem;

		&:hover {
			opacity: 0.9;
		}

		&.seccion-collapsed {
			opacity: 0.8;
		}

		i {
			font-size: 1rem;
			color: white;
			font-weight: bold;
		}

		.seccion-nombre {
			font-weight: bold;
		}
	}

	// Colores específicos por sección según la imagen
	&.seccion-cubierta {
		.seccion-header {
			background-color: #f44336; // Rojo para CUBIERTA
			border-bottom-color: #d32f2f;
		}
	}

	&.seccion-fonda {
		.seccion-header {
			background-color: #4caf50; // Verde para FONDA
			border-bottom-color: #388e3c;
		}
	}

	&.seccion-puente {
		.seccion-header {
			background-color: #2196f3; // Azul para PUENTE
			border-bottom-color: #1976d2;
		}
	}
}

.grupo-section {
	border: 2px solid transparent;

	.grupo-header {
		color: #000;
		font-weight: bold;
		padding: 0.75rem 1rem;
		border-bottom: 1px solid #dcdfe6;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		transition: all 0.2s;
		font-size: 0.9rem;
		position: relative;

		&:hover {
			opacity: 0.85;
		}

		&.grupo-collapsed {
			opacity: 0.9;
		}

		i {
			font-size: 0.9rem;
			color: #000;
			font-weight: bold;
		}

		.grupo-nombre {
			font-weight: bold;
		}
	}
}

// Bordes según la sección padre para PUENTE
.seccion-cubierta .grupo-section {
	border-color: #f44336; // Rojo para CUBIERTA
}

.seccion-fonda .grupo-section {
	border-color: #4caf50; // Verde para FONDA
}

.seccion-puente .grupo-section {
	border-color: #2196f3; // Azul para PUENTE
}

.grupo-section {
	.table-row {
		display: grid;
		grid-template-columns: 80px 200px 1fr 100px 120px 1fr 110px;
		border-bottom: 1px solid #c0c4cc;
		transition: background-color 0.2s;

		&:hover {
			background-color: rgba($--color-header, 0.05);
		}

		&.row-empty {
			opacity: 0.6;
		}

		> div {
			padding: 0.5rem;
			display: flex;
			align-items: center;
			border-right: 1px solid #c0c4cc;

			&:last-child {
				border-right: none;
			}
		}

		.col-posicion {
			justify-content: center;
		}

		.col-referencia {
			min-width: 0;

			::v-deep .el-input__inner {
				padding-left: 8px;
				padding-right: 8px;
			}
		}
	.col-equipo {
		display: flex;
		align-items: center;
		gap: 8px;

		.equipo-input-wrap {
			flex: 1 1 auto;
			min-width: 0;

			::v-deep .el-autocomplete,
			::v-deep .el-input {
				width: 100%;
			}
		}

		.talla-inline {
			flex: 0 0 180px;
			min-width: 80px;
		}
	}

		.row-con-documento {
			border-left: 3px solid #409eff;
			background-color: rgba(64, 158, 255, 0.06);
		}

		.col-acciones {
			justify-content: center;
			flex-wrap: wrap;
			gap: 4px;
			align-items: center;

			.indicador-documento {
				color: #409eff;
				font-size: 1rem;
				margin-right: 2px;
			}

			.el-button {
				margin: 0;
			}
		}

		// Estilos para los inputs dentro de las filas
		::v-deep .el-input {
			.el-input__inner {
				border-color: #c0c4cc;
				border-width: 1px;

				&:hover {
					border-color: #a0a4a8;
				}

				&:focus {
					border-color: $--color-primary;
				}

				&::placeholder {
					color: #909399;
					opacity: 1;
				}
			}
		}

		.col-cantidad {
			position: relative;

			::v-deep .el-input__inner {
				text-align: right;
				border-color: #c0c4cc;

				&:hover {
					border-color: #a0a4a8;
				}

				&:focus {
					border-color: $--color-primary;
				}

				&::placeholder {
					color: #909399;
					opacity: 1;
				}
			}

			::v-deep .el-input {
				width: 100%;
			}

			::v-deep .cantidad-pedido-invalida .el-input__inner {
				border-color: #f56c6c !important;
			}

			::v-deep .cantidad-pedido-invalida .el-input__inner:focus {
				border-color: #f56c6c !important;
				box-shadow: 0 0 0 1px rgba(245, 108, 108, 0.2);
			}

			.conversion-info {
				position: absolute;
				right: 8px;
				bottom: 2px;
				font-size: 12px;
				color: #606266;
				text-align: right;
				white-space: nowrap;
			}
		}
	}

	.add-line-button {
		padding: 0.5rem;
		text-align: center;
		border-top: 1px dashed #dcdfe6;
		background-color: rgba(255, 255, 255, 0.5);

		.el-button {
			color: $--color-primary;
			font-weight: 500;

			&:hover {
				color: darken($--color-primary, 10%);
			}

			&:disabled {
				color: #c0c4cc;
				cursor: not-allowed;
			}
		}
	}
}

// Colores de fondo por grupo (similar a Excel - azul claro para AG, verde claro para BM)
.grupo-ag {
	.grupo-header { background-color: #b3d9ff; }
	.table-row { background-color: rgba(179, 217, 255, 0.2); }
}
.grupo-bm {
	.grupo-header { background-color: #c8e6c9; }
	.table-row { background-color: rgba(200, 230, 201, 0.2); }
}
.grupo-cf {
	.grupo-header { background-color: #ffe0b2; }
	.table-row { background-color: rgba(255, 224, 178, 0.2); }
}
.grupo-ca {
	.grupo-header { background-color: #f8bbd0; }
	.table-row { background-color: rgba(248, 187, 208, 0.2); }
}
.grupo-dp {
	.grupo-header { background-color: #b2dfdb; }
	.table-row { background-color: rgba(178, 223, 219, 0.2); }
}
.grupo-el {
	.grupo-header { background-color: #fff9c4; }
	.table-row { background-color: rgba(255, 249, 196, 0.2); }
}
.grupo-fl {
	.grupo-header { background-color: #e1bee7; }
	.table-row { background-color: rgba(225, 190, 231, 0.2); }
}
.grupo-fr {
	.grupo-header { background-color: #b3e5fc; }
	.table-row { background-color: rgba(179, 229, 252, 0.2); }
}
.grupo-ga {
	.grupo-header { background-color: #c5cae9; }
	.table-row { background-color: rgba(197, 202, 233, 0.2); }
}
.grupo-ep {
	.grupo-header { background-color: #ffe082; }
	.table-row { background-color: rgba(255, 224, 130, 0.2); }
}
.grupo-he {
	.grupo-header { background-color: #dcedc8; }
	.table-row { background-color: rgba(220, 237, 200, 0.2); }
}
.grupo-hi {
	.grupo-header { background-color: #d1c4e9; }
	.table-row { background-color: rgba(209, 196, 233, 0.2); }
}
.grupo-hd {
	.grupo-header { background-color: #b2ebf2; }
	.table-row { background-color: rgba(178, 235, 242, 0.2); }
}
.grupo-mt {
	.grupo-header { background-color: #e0e0e0; }
	.table-row { background-color: rgba(224, 224, 224, 0.3); }
}
.grupo-mo {
	.grupo-header { background-color: #cfd8dc; }
	.table-row { background-color: rgba(207, 216, 220, 0.2); }
}
.grupo-mp {
	.grupo-header { background-color: #c8e6c9; }
	.table-row { background-color: rgba(200, 230, 201, 0.2); }
}
.grupo-pr {
	.grupo-header { background-color: #ffe0b2; }
	.table-row { background-color: rgba(255, 224, 178, 0.2); }
}
.grupo-ne {
	.grupo-header { background-color: #f8bbd0; }
	.table-row { background-color: rgba(248, 187, 208, 0.2); }
}
.grupo-pp {
	.grupo-header { background-color: #b2dfdb; }
	.table-row { background-color: rgba(178, 223, 219, 0.2); }
}
.grupo-pi {
	.grupo-header { background-color: #fff9c4; }
	.table-row { background-color: rgba(255, 249, 196, 0.2); }
}
.grupo-pc {
	.grupo-header { background-color: #e1bee7; }
	.table-row { background-color: rgba(225, 190, 231, 0.2); }
}
.grupo-qu {
	.grupo-header { background-color: #b3e5fc; }
	.table-row { background-color: rgba(179, 229, 252, 0.2); }
}
.grupo-ss {
	.grupo-header { background-color: #c5cae9; }
	.table-row { background-color: rgba(197, 202, 233, 0.2); }
}
.grupo-si {
	.grupo-header { background-color: #ffe082; }
	.table-row { background-color: rgba(255, 224, 130, 0.2); }
}
.grupo-sb {
	.grupo-header { background-color: #dcedc8; }
	.table-row { background-color: rgba(220, 237, 200, 0.2); }
}
.grupo-tr {
	.grupo-header { background-color: #d1c4e9; }
	.table-row { background-color: rgba(209, 196, 233, 0.2); }
}
.grupo-va {
	.grupo-header { background-color: #b2ebf2; }
	.table-row { background-color: rgba(178, 235, 242, 0.2); }
}
// .grupo-vr se aplica a VARIOS en todas las secciones
// Para CUBIERTA y FONDA usa #d9e1f2, para PUENTE usa #ebeef1
// Como hay múltiples VARIOS, se aplicará el último estilo definido
// Si necesitas diferenciarlos, se podría usar clases más específicas como .seccion-cubierta .grupo-vr
.grupo-vr {
	.grupo-header { background-color: #d9e1f2; }
	.table-row { background-color: rgba(217, 225, 242, 0.2); }
}

// Estilos específicos para VARIOS en sección PUENTE (último grupo)
.seccion-puente .grupo-vr {
	.grupo-header { background-color: #ebeef1; }
	.table-row { background-color: rgba(235, 238, 241, 0.3); }
}

// Estilos específicos para VARIOS en sección FONDA
.seccion-fonda .grupo-vr {
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); }
}

// Colores de fondo por grupo para PUENTE - Sección CUBIERTA
.grupo-cj {
	.grupo-header { background-color: #ebeef1; }
	.table-row { background-color: rgba(235, 238, 241, 0.3); }
}
.grupo-ch {
	.grupo-header { background-color: #e2efda; }
	.table-row { background-color: rgba(226, 239, 218, 0.2); }
}
.grupo-hf {
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); }
}
.grupo-jp {
	.grupo-header { background-color: #d9e1f2; }
	.table-row { background-color: rgba(217, 225, 242, 0.2); }
}
.grupo-mp {
	.grupo-header { background-color: #ebeef1; }
	.table-row { background-color: rgba(235, 238, 241, 0.3); }
}
.grupo-pi {
	.grupo-header { background-color: #e2efda; }
	.table-row { background-color: rgba(226, 239, 218, 0.2); }
}
.grupo-ql {
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); }
}

// Colores de fondo por grupo para PUENTE - Sección FONDA
.grupo-li {
	.grupo-header { background-color: #d9e1f2; }
	.table-row { background-color: rgba(217, 225, 242, 0.2); }
}
.grupo-me {
	.grupo-header { background-color: #e2efda; }
	.table-row { background-color: rgba(226, 239, 218, 0.2); }
}

// Colores de fondo por grupo para PUENTE - Sección PUENTE
.grupo-ep {
	.grupo-header { background-color: #d9e1f2; }
	.table-row { background-color: rgba(217, 225, 242, 0.2); }
}
.grupo-ll {
	.grupo-header { background-color: #e2efda; }
	.table-row { background-color: rgba(226, 239, 218, 0.2); }
}
.grupo-mo {
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); }
}
.grupo-se {
	.grupo-header { background-color: #d9e1f2; }
	.table-row { background-color: rgba(217, 225, 242, 0.2); }
}

// Nota: .grupo-vr está definido más arriba y se aplica a todos los VARIOS
// Si necesitas colores diferentes para VARIOS en cada sección, necesitaríamos clases más específicas

.propuesta-actions {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
	padding-top: 0.5rem;
	border-top: 1px solid #e4e7ed;
}

.propuesta-actions-left {
	display: flex;
	justify-content: flex-end;
	gap: 0.5rem;
}

.propuesta-actions-right {
	flex: 1;
	display: flex;
	justify-content: flex-start;
}

.confirmar-lanzar-mensaje {
	margin: 0 0 1rem 0;
	font-size: 1rem;
	line-height: 1.5;
}

.confirmar-lanzar-lista {
	max-height: 280px;
	overflow-y: auto;
	border: 1px solid #e4e7ed;
	border-radius: 4px;
	margin-bottom: 1rem;
}

.confirmar-lanzar-linea {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.5rem 0.75rem;
	border-bottom: 1px solid #ebeef5;
	font-size: 0.9rem;

	&:last-child {
		border-bottom: none;
	}
}

.confirmar-lanzar-equipo {
	flex: 1;
	margin-right: 1rem;
	word-break: break-word;
}

.confirmar-lanzar-cantidad {
	flex-shrink: 0;
	font-weight: 500;
	min-width: 2.5rem;
	text-align: right;
}

// Responsive
@media (max-width: 1200px) {
	.table-header,
	.table-row {
		grid-template-columns: 60px 165px 1fr 80px 100px 1fr 90px;
		font-size: 0.8rem;
	}
}

@media (max-width: 768px) {
	.propuesta-header .header-row {
		grid-template-columns: 1fr;
		gap: 0.5rem;
	}

	.table-header,
	.table-row {
		grid-template-columns: 50px 110px 1fr 70px 90px 1fr 80px;
		font-size: 0.75rem;
	}
}

// Campos no editables: texto legible (Element UI usa #c0c4cc en .is-disabled)
.propuesta-page ::v-deep .el-input.is-disabled .el-input__inner,
.propuesta-page ::v-deep .el-textarea.is-disabled .el-textarea__inner,
.propuesta-page ::v-deep .el-input-number.is-disabled .el-input__inner {
	color: #606266;
}
</style>
